import * as common_ng from '@leandredev/common_ng';
import { FormControlBase, FormDate, FormArrayOf, HttpServiceBase, HttpViewServiceBase, HttpAbstractService } from '@leandredev/common_ng';
export * from '@leandredev/common_ng';
import { FormControl, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';

function _mergeNamespaces(n, m) {
    m.forEach(function (e) {
        e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function (k) {
            if (k !== 'default' && !(k in n)) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    });
    return Object.freeze(n);
}

class field extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_description"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_humanName"] = new FormControl(null, Validators.compose([]));
        this["_isArrayOf"] = new FormControl(null, Validators.compose([]));
        this["_required"] = new FormControl(null, Validators.compose([]));
        this["_unique"] = new FormControl(null, Validators.compose([]));
        this["_index"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("field");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("humanName", this["_humanName"]);
        this.addControl("isArrayOf", this["_isArrayOf"]);
        this.addControl("required", this["_required"]);
        this.addControl("unique", this["_unique"]);
        this.addControl("index", this["_index"]);
    }
}
field.className = "field";

class modelid extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_ref"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("modelid");
        this.addControl("ref", this["_ref"]);
    }
}
modelid.className = "modelid";

class Field_boolean extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_default"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Field_boolean");
        this.addControl("default", this["_default"]);
    }
}
Field_boolean.className = "Field_boolean";

class Field_date extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_default"] = new FormDate(null, Validators.compose([]));
        this["_min"] = new FormDate(null, Validators.compose([]));
        this["_max"] = new FormDate(null, Validators.compose([]));
        this.controls._class.setValue("Field_date");
        this.addControl("default", this["_default"]);
        this.addControl("min", this["_min"]);
        this.addControl("max", this["_max"]);
    }
}
Field_date.className = "Field_date";

class Field_string extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_default"] = new FormControl(null, Validators.compose([]));
        this["_lowercase"] = new FormControl(null, Validators.compose([]));
        this["_uppercase"] = new FormControl(null, Validators.compose([]));
        this["_trim"] = new FormControl(null, Validators.compose([]));
        this["_match"] = new FormControl(null, Validators.compose([]));
        this["_enum"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("Field_string");
        this.addControl("default", this["_default"]);
        this.addControl("lowercase", this["_lowercase"]);
        this.addControl("uppercase", this["_uppercase"]);
        this.addControl("trim", this["_trim"]);
        this.addControl("match", this["_match"]);
        this.addControl("enum", this["_enum"]);
    }
}
Field_string.className = "Field_string";

class Field_texte extends Field_string {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("Field_texte");
    }
}
Field_texte.className = "Field_texte";

class Field_password extends Field_string {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("Field_password");
    }
}
Field_password.className = "Field_password";

class Field_number extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_default"] = new FormControl(null, Validators.compose([]));
        this["_min"] = new FormControl(null, Validators.compose([]));
        this["_max"] = new FormControl(null, Validators.compose([]));
        this["_step"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Field_number");
        this.addControl("default", this["_default"]);
        this.addControl("min", this["_min"]);
        this.addControl("max", this["_max"]);
        this.addControl("step", this["_step"]);
    }
}
Field_number.className = "Field_number";

class Field_objectid extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_ref"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("Field_objectid");
        this.addControl("ref", this["_ref"]);
    }
}
Field_objectid.className = "Field_objectid";

class Field_htmltexte extends Field_string {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("Field_htmltexte");
    }
}
Field_htmltexte.className = "Field_htmltexte";

class Field_object extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("Field_object");
    }
}
Field_object.className = "Field_object";

class castParam extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_paramName"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_type"] = new FormControl(null, Validators.compose([]));
        this["_param"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("castParam");
        this.addControl("paramName", this["_paramName"]);
        this.addControl("type", this["_type"]);
        this.addControl("param", this["_param"]);
    }
}
castParam.className = "castParam";

class routeParam extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_paramName"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_type"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("routeParam");
        this.addControl("paramName", this["_paramName"]);
        this.addControl("type", this["_type"]);
    }
}
routeParam.className = "routeParam";

class subdoc extends field {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_protoSchemaId"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("subdoc");
        this.addControl("protoSchemaId", this["_protoSchemaId"]);
    }
}
subdoc.className = "subdoc";

class SwaggerApi extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this["_paths"] = new FormArrayOf(SwaggerPath);
        this.controls._class.setValue("SwaggerApi");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("paths", this["_paths"]);
    }
}
SwaggerApi.className = "SwaggerApi";

class SwaggerPath extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this["_path"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_verbe"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_bodyFormat"] = new FormControl("json", Validators.compose([]));
        this["_returnFormat"] = new FormControl("json", Validators.compose([]));
        this["_pathParams"] = new FormArrayOf(SwaggerParams);
        this["_queryParams"] = new FormArrayOf(SwaggerParams);
        this["_bodyParam"] = new FormControl(null, Validators.compose([]));
        this["_returnType"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SwaggerPath");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("path", this["_path"]);
        this.addControl("verbe", this["_verbe"]);
        this.addControl("bodyFormat", this["_bodyFormat"]);
        this.addControl("returnFormat", this["_returnFormat"]);
        this.addControl("pathParams", this["_pathParams"]);
        this.addControl("queryParams", this["_queryParams"]);
        this.addControl("bodyParam", this["_bodyParam"]);
        this.addControl("returnType", this["_returnType"]);
    }
}
SwaggerPath.className = "SwaggerPath";

class _view extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_description"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_output"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_model"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_pipeline"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("_view");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("output", this["_output"]);
        this.addControl("model", this["_model"]);
        this.addControl("pipeline", this["_pipeline"]);
    }
}
_view.className = "_view";

class _view_params extends _view {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_params"] = new FormArrayOf(routeParam);
        this["_castParams"] = new FormArrayOf(castParam);
        this.controls._class.setValue("_view_params");
        this.addControl("params", this["_params"]);
        this.addControl("castParams", this["_castParams"]);
    }
}
_view_params.className = "_view_params";

class SwaggerParams extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this["_require"] = new FormControl(null, Validators.compose([]));
        this["_type"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("SwaggerParams");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("require", this["_require"]);
        this.addControl("type", this["_type"]);
    }
}
SwaggerParams.className = "SwaggerParams";

class FormSectorSurveyAnswer extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_answer"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("FormSectorSurveyAnswer");
        this.addControl("answer", this["_answer"]);
    }
}
FormSectorSurveyAnswer.className = "FormSectorSurveyAnswer";

class FormSectorSurveyAnswer_Number extends FormSectorSurveyAnswer {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_value"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("FormSectorSurveyAnswer_Number");
        this.addControl("value", this["_value"]);
    }
}
FormSectorSurveyAnswer_Number.className = "FormSectorSurveyAnswer_Number";

class FormSectorSurveyAnswer_String extends FormSectorSurveyAnswer {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_value"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("FormSectorSurveyAnswer_String");
        this.addControl("value", this["_value"]);
    }
}
FormSectorSurveyAnswer_String.className = "FormSectorSurveyAnswer_String";

class ShareClass extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("ShareClass");
        this.addControl("name", this["_name"]);
    }
}
ShareClass.className = "ShareClass";

class Issue extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_parentIssue"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Issue");
        this.addControl("name", this["_name"]);
        this.addControl("parentIssue", this["_parentIssue"]);
    }
}
Issue.className = "Issue";

class protoschema extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_description"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_humanName"] = new FormControl(null, Validators.compose([]));
        this["_isAbstract"] = new FormControl(null, Validators.compose([]));
        this["_isSchema"] = new FormControl(null, Validators.compose([]));
        this["_isEnum"] = new FormControl(null, Validators.compose([]));
        this["_parentModel"] = new FormControl(null, Validators.compose([]));
        this["_fields"] = new FormArrayOf(field);
        this["_uiNameValue"] = new FormControl("name", Validators.compose([]));
        this.controls._class.setValue("protoschema");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("humanName", this["_humanName"]);
        this.addControl("isAbstract", this["_isAbstract"]);
        this.addControl("isSchema", this["_isSchema"]);
        this.addControl("isEnum", this["_isEnum"]);
        this.addControl("parentModel", this["_parentModel"]);
        this.addControl("fields", this["_fields"]);
        this.addControl("uiNameValue", this["_uiNameValue"]);
    }
}
protoschema.className = "protoschema";

class Space extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_sectorSurvey"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Space");
        this.addControl("name", this["_name"]);
        this.addControl("sectorSurvey", this["_sectorSurvey"]);
    }
    get "_labelIssue"() {
        if (!this.controls["labelIssue"]) {
            let temp = new SpaceLabelOfIssue({}, Validators.compose([]));
            this.addControl("labelIssue", temp);
        }
        return this.controls["labelIssue"];
    }
    set "_labelIssue"(value) {
        if (this["__labelIssue"]) {
            this.removeControl("labelIssue");
        }
        this["__labelIssue"] = value;
        this.addControl("labelIssue", this["__labelIssue"]);
    }
}
Space.className = "Space";

class CompanySector extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_space"] = new FormControl(null, Validators.compose([]));
        this["_label"] = new FormControl(null, Validators.compose([]));
        this["_summaryOfThemes"] = new FormControl(null, Validators.compose([]));
        this["_weightIssue"] = new FormArrayOf(SpaceLabelOfIssue);
        this.controls._class.setValue("CompanySector");
        this.addControl("name", this["_name"]);
        this.addControl("space", this["_space"]);
        this.addControl("label", this["_label"]);
        this.addControl("summaryOfThemes", this["_summaryOfThemes"]);
        this.addControl("weightIssue", this["_weightIssue"]);
    }
}
CompanySector.className = "CompanySector";

class FormSectorSurvey extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_question"] = new FormControl(null, Validators.compose([]));
        this["_hasFreeAnswer"] = new FormControl(null, Validators.compose([]));
        this["_multiAnswer"] = new FormControl(null, Validators.compose([]));
        this["_filter"] = new FormArrayOf(ActionSelector);
        this.controls._class.setValue("FormSectorSurvey");
        this.addControl("name", this["_name"]);
        this.addControl("question", this["_question"]);
        this.addControl("hasFreeAnswer", this["_hasFreeAnswer"]);
        this.addControl("multiAnswer", this["_multiAnswer"]);
        this.addControl("filter", this["_filter"]);
    }
}
FormSectorSurvey.className = "FormSectorSurvey";

class FormSectorSurvey_String extends FormSectorSurvey {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_values"] = new FormArrayOf(FormControl);
        this["_renderer"] = new FormControl("radio", Validators.compose([]));
        this["_answers"] = new FormArrayOf(FormSectorSurveyAnswer_String);
        this.controls._class.setValue("FormSectorSurvey_String");
        this.addControl("values", this["_values"]);
        this.addControl("renderer", this["_renderer"]);
        this.addControl("answers", this["_answers"]);
    }
}
FormSectorSurvey_String.className = "FormSectorSurvey_String";

class FormSectorSurvey_Number extends FormSectorSurvey {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_value"] = new FormArrayOf(FormControl);
        this["_renderer"] = new FormControl("radio", Validators.compose([]));
        this["_answers"] = new FormArrayOf(FormSectorSurveyAnswer_Number);
        this.controls._class.setValue("FormSectorSurvey_Number");
        this.addControl("value", this["_value"]);
        this.addControl("renderer", this["_renderer"]);
        this.addControl("answers", this["_answers"]);
    }
}
FormSectorSurvey_Number.className = "FormSectorSurvey_Number";

class User extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_email"] = new FormControl(null, Validators.compose([]));
        this["_picture"] = new FormControl(null, Validators.compose([]));
        this["_createdAt"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_lastConnexionDate"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_firstName"] = new FormControl(null, Validators.compose([]));
        this["_phone"] = new FormControl(null, Validators.compose([]));
        this["_lastName"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("User");
        this.addControl("name", this["_name"]);
        this.addControl("email", this["_email"]);
        this.addControl("picture", this["_picture"]);
        this.addControl("createdAt", this["_createdAt"]);
        this.addControl("lastConnexionDate", this["_lastConnexionDate"]);
        this.addControl("firstName", this["_firstName"]);
        this.addControl("phone", this["_phone"]);
        this.addControl("lastName", this["_lastName"]);
    }
}
User.className = "User";

class SigninRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_password"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_login"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("SigninRequest");
        this.addControl("password", this["_password"]);
        this.addControl("login", this["_login"]);
    }
}
SigninRequest.className = "SigninRequest";

class SigninResponse extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_id_token"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SigninResponse");
        this.addControl("id_token", this["_id_token"]);
    }
}
SigninResponse.className = "SigninResponse";

class FormSectorSurveyUserAnswer extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_questionId"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_answers"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("FormSectorSurveyUserAnswer");
        this.addControl("questionId", this["_questionId"]);
        this.addControl("answers", this["_answers"]);
    }
}
FormSectorSurveyUserAnswer.className = "FormSectorSurveyUserAnswer";

class resetPasswordRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_password"] = new FormControl(null, Validators.compose([]));
        this["_resetPasswordKey"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("resetPasswordRequest");
        this.addControl("password", this["_password"]);
        this.addControl("resetPasswordKey", this["_resetPasswordKey"]);
    }
}
resetPasswordRequest.className = "resetPasswordRequest";

class AnswerValue extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("AnswerValue");
    }
}
AnswerValue.className = "AnswerValue";

class AnswerValue_String extends AnswerValue {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_value"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("AnswerValue_String");
        this.addControl("value", this["_value"]);
    }
}
AnswerValue_String.className = "AnswerValue_String";

class AnswerValue_Number extends AnswerValue {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_value"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("AnswerValue_Number");
        this.addControl("value", this["_value"]);
    }
}
AnswerValue_Number.className = "AnswerValue_Number";

class CompanySectorSectorSurveyCombinationMapping extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_sectorSurveyAnswerCombination"] = new FormArrayOf(AnswerValue);
        this["_companySector"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("CompanySectorSectorSurveyCombinationMapping");
        this.addControl("sectorSurveyAnswerCombination", this["_sectorSurveyAnswerCombination"]);
        this.addControl("companySector", this["_companySector"]);
    }
}
CompanySectorSectorSurveyCombinationMapping.className = "CompanySectorSectorSurveyCombinationMapping";

class FsoImage extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_url"] = new FormControl(null, Validators.compose([]));
        this["_originalName"] = new FormControl(null, Validators.compose([]));
        this["_imageId"] = new FormControl(null, Validators.compose([]));
        this["_name"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("FsoImage");
        this.addControl("url", this["_url"]);
        this.addControl("originalName", this["_originalName"]);
        this.addControl("imageId", this["_imageId"]);
        this.addControl("name", this["_name"]);
    }
}
FsoImage.className = "FsoImage";

class SpaceLabelOfIssue extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_label"] = new FormControl(null, Validators.compose([]));
        this["_issue"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SpaceLabelOfIssue");
        this.addControl("label", this["_label"]);
        this.addControl("issue", this["_issue"]);
    }
}
SpaceLabelOfIssue.className = "SpaceLabelOfIssue";

class ContentItem extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_title"] = new FormControl(null, Validators.compose([]));
        this["_subTitle"] = new FormControl(null, Validators.compose([]));
        this["_htmlText"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ContentItem");
        this.addControl("name", this["_name"]);
        this.addControl("title", this["_title"]);
        this.addControl("subTitle", this["_subTitle"]);
        this.addControl("htmlText", this["_htmlText"]);
    }
    get "_fsoImage"() {
        if (!this.controls["fsoImage"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("fsoImage", temp);
        }
        return this.controls["fsoImage"];
    }
    set "_fsoImage"(value) {
        if (this["__fsoImage"]) {
            this.removeControl("fsoImage");
        }
        this["__fsoImage"] = value;
        this.addControl("fsoImage", this["__fsoImage"]);
    }
}
ContentItem.className = "ContentItem";

class ContentItem_TextRIgth_Picture_Left extends ContentItem {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_htmlText"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ContentItem_TextRIgth_Picture_Left");
        this.addControl("htmlText", this["_htmlText"]);
    }
    get "_image"() {
        if (!this.controls["image"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("image", temp);
        }
        return this.controls["image"];
    }
    set "_image"(value) {
        if (this["__image"]) {
            this.removeControl("image");
        }
        this["__image"] = value;
        this.addControl("image", this["__image"]);
    }
}
ContentItem_TextRIgth_Picture_Left.className = "ContentItem_TextRIgth_Picture_Left";

class ContentItem_TextLeft_Picture_Rigth extends ContentItem {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_htmlText"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ContentItem_TextLeft_Picture_Rigth");
        this.addControl("htmlText", this["_htmlText"]);
    }
    get "_image"() {
        if (!this.controls["image"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("image", temp);
        }
        return this.controls["image"];
    }
    set "_image"(value) {
        if (this["__image"]) {
            this.removeControl("image");
        }
        this["__image"] = value;
        this.addControl("image", this["__image"]);
    }
}
ContentItem_TextLeft_Picture_Rigth.className = "ContentItem_TextLeft_Picture_Rigth";

class Content$1 extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_title"] = new FormControl(null, Validators.compose([]));
        this["_ContentType"] = new FormControl(null, Validators.compose([]));
        this["_introduction"] = new FormControl(null, Validators.compose([]));
        this["_contentItems"] = new FormArrayOf(ContentItem);
        this["_body"] = new FormControl(null, Validators.compose([]));
        this["_footer"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Content");
        this.addControl("name", this["_name"]);
        this.addControl("title", this["_title"]);
        this.addControl("ContentType", this["_ContentType"]);
        this.addControl("introduction", this["_introduction"]);
        this.addControl("contentItems", this["_contentItems"]);
        this.addControl("body", this["_body"]);
        this.addControl("footer", this["_footer"]);
    }
    get "_image"() {
        if (!this.controls["image"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("image", temp);
        }
        return this.controls["image"];
    }
    set "_image"(value) {
        if (this["__image"]) {
            this.removeControl("image");
        }
        this["__image"] = value;
        this.addControl("image", this["__image"]);
    }
}
Content$1.className = "Content";

class SummaryCompletion extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_completion"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SummaryCompletion");
        this.addControl("completion", this["_completion"]);
    }
}
SummaryCompletion.className = "SummaryCompletion";

class CompanyEntitySurveyState extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_answers"] = new FormArrayOf(AnswerValue);
        this["_completion"] = new FormControl("none", Validators.compose([]));
        this["_requiredAnswers"] = new FormControl(null, Validators.compose([]));
        this["_results"] = new FormArrayOf(SummarySurveyComputation);
        this.controls._class.setValue("CompanyEntitySurveyState");
        this.addControl("answers", this["_answers"]);
        this.addControl("completion", this["_completion"]);
        this.addControl("requiredAnswers", this["_requiredAnswers"]);
        this.addControl("results", this["_results"]);
    }
}
CompanyEntitySurveyState.className = "CompanyEntitySurveyState";

class CompanyEntitySummarySurveyState extends CompanyEntitySurveyState {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_summaryCompletion"] = new FormArrayOf(SummaryCompletion);
        this["_requiredAnswers"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("CompanyEntitySummarySurveyState");
        this.addControl("summaryCompletion", this["_summaryCompletion"]);
        this.addControl("requiredAnswers", this["_requiredAnswers"]);
    }
}
CompanyEntitySummarySurveyState.className = "CompanyEntitySummarySurveyState";

class File extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_fieldname"] = new FormControl(null, Validators.compose([]));
        this["_originalname"] = new FormControl(null, Validators.compose([]));
        this["_encoding"] = new FormControl(null, Validators.compose([]));
        this["_mimetype"] = new FormControl(null, Validators.compose([]));
        this["_size"] = new FormControl(null, Validators.compose([]));
        this["_destination"] = new FormControl(null, Validators.compose([]));
        this["_filename"] = new FormControl(null, Validators.compose([]));
        this["_path"] = new FormControl(null, Validators.compose([]));
        this["_createdAt"] = new FormDate(null, Validators.compose([]));
        this["_updatedAt"] = new FormDate(null, Validators.compose([]));
        this["_serviceUrl"] = new FormControl(null, Validators.compose([]));
        this["_directories"] = new FormArrayOf(FormControl);
        this["_url"] = new FormControl(null, Validators.compose([]));
        this["_fileUrl"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("File");
        this.addControl("fieldname", this["_fieldname"]);
        this.addControl("originalname", this["_originalname"]);
        this.addControl("encoding", this["_encoding"]);
        this.addControl("mimetype", this["_mimetype"]);
        this.addControl("size", this["_size"]);
        this.addControl("destination", this["_destination"]);
        this.addControl("filename", this["_filename"]);
        this.addControl("path", this["_path"]);
        this.addControl("createdAt", this["_createdAt"]);
        this.addControl("updatedAt", this["_updatedAt"]);
        this.addControl("serviceUrl", this["_serviceUrl"]);
        this.addControl("directories", this["_directories"]);
        this.addControl("url", this["_url"]);
        this.addControl("fileUrl", this["_fileUrl"]);
    }
    get "__acl"() {
        if (!this.controls["_acl"]) {
            let temp = new _acl({}, Validators.compose([]));
            this.addControl("_acl", temp);
        }
        return this.controls["_acl"];
    }
    set "__acl"(value) {
        if (this["___acl"]) {
            this.removeControl("_acl");
        }
        this["___acl"] = value;
        this.addControl("_acl", this["___acl"]);
    }
}
File.className = "File";

class _acl extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_creator"] = new FormControl(null, Validators.compose([]));
        this["_readers"] = new FormArrayOf(aclIdentity);
        this["_writers"] = new FormArrayOf(aclIdentity);
        this["_admins"] = new FormArrayOf(aclIdentity);
        this.controls._class.setValue("_acl");
        this.addControl("creator", this["_creator"]);
        this.addControl("readers", this["_readers"]);
        this.addControl("writers", this["_writers"]);
        this.addControl("admins", this["_admins"]);
    }
}
_acl.className = "_acl";

class aclIdentity extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_end_client"] = new FormControl(null, Validators.compose([]));
        this["_applicaton_instance"] = new FormControl(null, Validators.compose([]));
        this["_role"] = new FormControl(null, Validators.compose([]));
        this["_user"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("aclIdentity");
        this.addControl("end_client", this["_end_client"]);
        this.addControl("applicaton_instance", this["_applicaton_instance"]);
        this.addControl("role", this["_role"]);
        this.addControl("user", this["_user"]);
    }
}
aclIdentity.className = "aclIdentity";

class ComputeData extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_label"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_total"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_actions"] = new FormArrayOf(ComputeActionData);
        this.controls._class.setValue("ComputeData");
        this.addControl("label", this["_label"]);
        this.addControl("total", this["_total"]);
        this.addControl("actions", this["_actions"]);
    }
}
ComputeData.className = "ComputeData";

class SummarySurveyComputation extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_SummaryItemOfSurveyId"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_parentItemid"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_computedData"] = new ComputeData({}, Validators.compose([Validators.required]));
        this.controls._class.setValue("SummarySurveyComputation");
        this.addControl("SummaryItemOfSurveyId", this["_SummaryItemOfSurveyId"]);
        this.addControl("parentItemid", this["_parentItemid"]);
        this.addControl("computedData", this["_computedData"]);
    }
}
SummarySurveyComputation.className = "SummarySurveyComputation";

class ComputeActionData extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_actionId"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_label"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_values"] = new FormArrayOf(FormControl);
        this["_weighting"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_feasibility"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_impact"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("ComputeActionData");
        this.addControl("actionId", this["_actionId"]);
        this.addControl("label", this["_label"]);
        this.addControl("values", this["_values"]);
        this.addControl("weighting", this["_weighting"]);
        this.addControl("feasibility", this["_feasibility"]);
        this.addControl("impact", this["_impact"]);
    }
}
ComputeActionData.className = "ComputeActionData";

class ActionSelector extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("ActionSelector");
    }
}
ActionSelector.className = "ActionSelector";

class ActionSelector_String extends ActionSelector {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_subject"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_operator"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_value"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("ActionSelector_String");
        this.addControl("subject", this["_subject"]);
        this.addControl("operator", this["_operator"]);
        this.addControl("value", this["_value"]);
    }
}
ActionSelector_String.className = "ActionSelector_String";

class UpdateCompanyEntityStatesRequiredAnswers extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_entityId"] = new FormControl(null, Validators.compose([]));
        this["_sectorRequiredAnswers"] = new FormControl(null, Validators.compose([]));
        this["_summaryRequiredAnswers"] = new FormControl(null, Validators.compose([]));
        this["_summarySurveyId"] = new FormControl(null, Validators.compose([]));
        this["_sectorSurveyId"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("UpdateCompanyEntityStatesRequiredAnswers");
        this.addControl("entityId", this["_entityId"]);
        this.addControl("sectorRequiredAnswers", this["_sectorRequiredAnswers"]);
        this.addControl("summaryRequiredAnswers", this["_summaryRequiredAnswers"]);
        this.addControl("summarySurveyId", this["_summarySurveyId"]);
        this.addControl("sectorSurveyId", this["_sectorSurveyId"]);
    }
}
UpdateCompanyEntityStatesRequiredAnswers.className = "UpdateCompanyEntityStatesRequiredAnswers";

class ActionSelector_Sector extends ActionSelector {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_subject"] = new FormControl("sector", Validators.compose([Validators.required]));
        this["_operator"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_value"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("ActionSelector_Sector");
        this.addControl("subject", this["_subject"]);
        this.addControl("operator", this["_operator"]);
        this.addControl("value", this["_value"]);
    }
}
ActionSelector_Sector.className = "ActionSelector_Sector";

class ActionSelector_And extends ActionSelector {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_actions"] = new FormArrayOf(ActionSelector);
        this.controls._class.setValue("ActionSelector_And");
        this.addControl("actions", this["_actions"]);
    }
}
ActionSelector_And.className = "ActionSelector_And";

class ActionSelector_Or extends ActionSelector {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_actions"] = new FormArrayOf(ActionSelector);
        this.controls._class.setValue("ActionSelector_Or");
        this.addControl("actions", this["_actions"]);
    }
}
ActionSelector_Or.className = "ActionSelector_Or";

class ActionSelector_Number extends ActionSelector {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_subject"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_operator"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_value"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("ActionSelector_Number");
        this.addControl("subject", this["_subject"]);
        this.addControl("operator", this["_operator"]);
        this.addControl("value", this["_value"]);
    }
}
ActionSelector_Number.className = "ActionSelector_Number";

class SummarySurveyFilterRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_answer"] = new FormArrayOf(AnswerValue);
        this["_companySector"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SummarySurveyFilterRequest");
        this.addControl("answer", this["_answer"]);
        this.addControl("companySector", this["_companySector"]);
    }
}
SummarySurveyFilterRequest.className = "SummarySurveyFilterRequest";

class PatchSelectedAction extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_actionId"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_entityId"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("PatchSelectedAction");
        this.addControl("actionId", this["_actionId"]);
        this.addControl("entityId", this["_entityId"]);
    }
}
PatchSelectedAction.className = "PatchSelectedAction";

class ContactResponse extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_contectResponse"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ContactResponse");
        this.addControl("contectResponse", this["_contectResponse"]);
    }
}
ContactResponse.className = "ContactResponse";

class generatePdfRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_url"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_context"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("generatePdfRequest");
        this.addControl("url", this["_url"]);
        this.addControl("context", this["_context"]);
    }
}
generatePdfRequest.className = "generatePdfRequest";

class VisualComponent extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("VisualComponent");
    }
}
VisualComponent.className = "VisualComponent";

class MEA_Block extends VisualComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("MEA_Block");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
    }
}
MEA_Block.className = "MEA_Block";

class VisualPageComponent extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("VisualPageComponent");
    }
}
VisualPageComponent.className = "VisualPageComponent";

class LandingPage extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_title"] = new FormControl(null, Validators.compose([]));
        this["_contents"] = new FormArrayOf(VisualPageComponent);
        this.controls._class.setValue("LandingPage");
        this.addControl("name", this["_name"]);
        this.addControl("title", this["_title"]);
        this.addControl("contents", this["_contents"]);
    }
}
LandingPage.className = "LandingPage";

class Invitation extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this["_recipient"] = new FormControl(null, Validators.compose([]));
        this["_hasBeenUsed"] = new FormControl(null, Validators.compose([]));
        this["_message"] = new FormControl(null, Validators.compose([]));
        this["_invitationMailTemplate"] = new FormControl(null, Validators.compose([]));
        this["_partnerLandingPage"] = new FormControl(null, Validators.compose([]));
        this["_hasBennSended"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Invitation");
        this.addControl("partner", this["_partner"]);
        this.addControl("recipient", this["_recipient"]);
        this.addControl("hasBeenUsed", this["_hasBeenUsed"]);
        this.addControl("message", this["_message"]);
        this.addControl("invitationMailTemplate", this["_invitationMailTemplate"]);
        this.addControl("partnerLandingPage", this["_partnerLandingPage"]);
        this.addControl("hasBennSended", this["_hasBennSended"]);
    }
}
Invitation.className = "Invitation";

class MultipleInvitationRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_invitations"] = new FormArrayOf(Invitation);
        this.controls._class.setValue("MultipleInvitationRequest");
        this.addControl("invitations", this["_invitations"]);
    }
}
MultipleInvitationRequest.className = "MultipleInvitationRequest";

class ImgSideBySide extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_ltr"] = new FormControl(null, Validators.compose([]));
        this["_content"] = new FormArrayOf(VisualComponent);
        this.controls._class.setValue("ImgSideBySide");
        this.addControl("ltr", this["_ltr"]);
        this.addControl("content", this["_content"]);
    }
    get "_img"() {
        if (!this.controls["img"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("img", temp);
        }
        return this.controls["img"];
    }
    set "_img"(value) {
        if (this["__img"]) {
            this.removeControl("img");
        }
        this["__img"] = value;
        this.addControl("img", this["__img"]);
    }
}
ImgSideBySide.className = "ImgSideBySide";

class TitreSousTitre extends VisualComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("TitreSousTitre");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
    }
}
TitreSousTitre.className = "TitreSousTitre";

class SummarySynthesisPage extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_title"] = new FormControl(null, Validators.compose([]));
        this["_contents"] = new FormArrayOf(VisualPageComponent);
        this.controls._class.setValue("SummarySynthesisPage");
        this.addControl("name", this["_name"]);
        this.addControl("title", this["_title"]);
        this.addControl("contents", this["_contents"]);
    }
}
SummarySynthesisPage.className = "SummarySynthesisPage";

class SummaryIntroductionPage extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_title"] = new FormControl(null, Validators.compose([]));
        this["_contents"] = new FormArrayOf(VisualPageComponent);
        this.controls._class.setValue("SummaryIntroductionPage");
        this.addControl("name", this["_name"]);
        this.addControl("title", this["_title"]);
        this.addControl("contents", this["_contents"]);
    }
}
SummaryIntroductionPage.className = "SummaryIntroductionPage";

class Button extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_label"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_url"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_icon"] = new FormControl(null, Validators.compose([]));
        this["_cssClass"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Button");
        this.addControl("label", this["_label"]);
        this.addControl("url", this["_url"]);
        this.addControl("icon", this["_icon"]);
        this.addControl("cssClass", this["_cssClass"]);
    }
}
Button.className = "Button";

class CallToAction extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this["_buttons"] = new FormArrayOf(Button);
        this.controls._class.setValue("CallToAction");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("buttons", this["_buttons"]);
    }
}
CallToAction.className = "CallToAction";

class MEA_Block_Text extends MEA_Block {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_indice"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("MEA_Block_Text");
        this.addControl("indice", this["_indice"]);
    }
}
MEA_Block_Text.className = "MEA_Block_Text";

class MEA_Block_Image extends MEA_Block {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("MEA_Block_Image");
    }
    get "_img"() {
        if (!this.controls["img"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("img", temp);
        }
        return this.controls["img"];
    }
    set "_img"(value) {
        if (this["__img"]) {
            this.removeControl("img");
        }
        this["__img"] = value;
        this.addControl("img", this["__img"]);
    }
}
MEA_Block_Image.className = "MEA_Block_Image";

class MEA_Block_Icon extends MEA_Block {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_icon"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("MEA_Block_Icon");
        this.addControl("icon", this["_icon"]);
    }
    get "_img"() {
        if (!this.controls["img"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("img", temp);
        }
        return this.controls["img"];
    }
    set "_img"(value) {
        if (this["__img"]) {
            this.removeControl("img");
        }
        this["__img"] = value;
        this.addControl("img", this["__img"]);
    }
}
MEA_Block_Icon.className = "MEA_Block_Icon";

class UIThemeSummary extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("UIThemeSummary");
    }
}
UIThemeSummary.className = "UIThemeSummary";

class UISynthesisThemeList extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("UISynthesisThemeList");
    }
}
UISynthesisThemeList.className = "UISynthesisThemeList";

class UITitleSubtitle extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_title"] = new FormControl(null, Validators.compose([]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("UITitleSubtitle");
        this.addControl("title", this["_title"]);
        this.addControl("description", this["_description"]);
    }
}
UITitleSubtitle.className = "UITitleSubtitle";

class UISurveyTime extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_questionDuration"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("UISurveyTime");
        this.addControl("questionDuration", this["_questionDuration"]);
    }
}
UISurveyTime.className = "UISurveyTime";

class UIMEA2 extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("UIMEA2");
    }
    get "_bloc1"() {
        if (!this.controls["bloc1"]) {
            let temp = new MEA_Block({}, Validators.compose([]));
            this.addControl("bloc1", temp);
        }
        return this.controls["bloc1"];
    }
    set "_bloc1"(value) {
        if (this["__bloc1"]) {
            this.removeControl("bloc1");
        }
        this["__bloc1"] = value;
        this.addControl("bloc1", this["__bloc1"]);
    }
    get "_bloc2"() {
        if (!this.controls["bloc2"]) {
            let temp = new MEA_Block({}, Validators.compose([]));
            this.addControl("bloc2", temp);
        }
        return this.controls["bloc2"];
    }
    set "_bloc2"(value) {
        if (this["__bloc2"]) {
            this.removeControl("bloc2");
        }
        this["__bloc2"] = value;
        this.addControl("bloc2", this["__bloc2"]);
    }
}
UIMEA2.className = "UIMEA2";

class CsvRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_filter"] = new FormControl(null, Validators.compose([]));
        this["_data"] = new FormArrayOf(FormControl);
        this["_importDataType"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("CsvRequest");
        this.addControl("filter", this["_filter"]);
        this.addControl("data", this["_data"]);
        this.addControl("importDataType", this["_importDataType"]);
    }
}
CsvRequest.className = "CsvRequest";

class PatchSelectedActions extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_actionId"] = new FormArrayOf(FormControl);
        this["_entityId"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("PatchSelectedActions");
        this.addControl("actionId", this["_actionId"]);
        this.addControl("entityId", this["_entityId"]);
    }
}
PatchSelectedActions.className = "PatchSelectedActions";

class address extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_address1"] = new FormControl(null, Validators.compose([]));
        this["_address2"] = new FormControl(null, Validators.compose([]));
        this["_zipCode"] = new FormControl(null, Validators.compose([]));
        this["_city"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("address");
        this.addControl("address1", this["_address1"]);
        this.addControl("address2", this["_address2"]);
        this.addControl("zipCode", this["_zipCode"]);
        this.addControl("city", this["_city"]);
    }
}
address.className = "address";

class RoadmapPage extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_contents"] = new FormArrayOf(VisualPageComponent);
        this["_contents2"] = new FormArrayOf(VisualPageComponent);
        this.controls._class.setValue("RoadmapPage");
        this.addControl("name", this["_name"]);
        this.addControl("contents", this["_contents"]);
        this.addControl("contents2", this["_contents2"]);
    }
}
RoadmapPage.className = "RoadmapPage";

class SummarySurvey$1 extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_space"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_items"] = new FormArrayOf(SummaryItemOfSurvey);
        this["_roadmap"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SummarySurvey");
        this.addControl("name", this["_name"]);
        this.addControl("space", this["_space"]);
        this.addControl("items", this["_items"]);
        this.addControl("roadmap", this["_roadmap"]);
    }
}
SummarySurvey$1.className = "SummarySurvey";

class ContactRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_userMail"] = new FormControl(null, Validators.compose([]));
        this["_contactName"] = new FormControl(null, Validators.compose([]));
        this["_userMessage"] = new FormControl(null, Validators.compose([]));
        this["_partnerMail"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ContactRequest");
        this.addControl("userMail", this["_userMail"]);
        this.addControl("contactName", this["_contactName"]);
        this.addControl("userMessage", this["_userMessage"]);
        this.addControl("partnerMail", this["_partnerMail"]);
    }
}
ContactRequest.className = "ContactRequest";

class AnswerValueName extends AnswerValue {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("AnswerValueName");
        this.addControl("name", this["_name"]);
    }
}
AnswerValueName.className = "AnswerValueName";

class AnswerValueName_String extends AnswerValueName {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_value"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("AnswerValueName_String");
        this.addControl("value", this["_value"]);
    }
}
AnswerValueName_String.className = "AnswerValueName_String";

class AnswerValueName_Number extends AnswerValueName {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_value"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("AnswerValueName_Number");
        this.addControl("value", this["_value"]);
    }
}
AnswerValueName_Number.className = "AnswerValueName_Number";

class DatavizResponse extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_results"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("DatavizResponse");
        this.addControl("results", this["_results"]);
    }
}
DatavizResponse.className = "DatavizResponse";

class RouterProxy extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_queryKey"] = new FormControl(null, Validators.compose([]));
        this["_status"] = new FormControl(null, Validators.compose([]));
        this["_result"] = new FormControl(null, Validators.compose([]));
        this["_error"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("RouterProxy");
        this.addControl("queryKey", this["_queryKey"]);
        this.addControl("status", this["_status"]);
        this.addControl("result", this["_result"]);
        this.addControl("error", this["_error"]);
    }
}
RouterProxy.className = "RouterProxy";

class DatavizAnswerByAction extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_action"] = new FormControl(null, Validators.compose([]));
        this["_size"] = new FormControl(null, Validators.compose([]));
        this["_percent"] = new FormControl(null, Validators.compose([]));
        this["_nb"] = new FormControl(null, Validators.compose([]));
        this["_total"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("DatavizAnswerByAction");
        this.addControl("action", this["_action"]);
        this.addControl("size", this["_size"]);
        this.addControl("percent", this["_percent"]);
        this.addControl("nb", this["_nb"]);
        this.addControl("total", this["_total"]);
    }
}
DatavizAnswerByAction.className = "DatavizAnswerByAction";

class AddPartnerInput extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_legalName"] = new FormControl(null, Validators.compose([]));
        this["_technicalName"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("AddPartnerInput");
        this.addControl("name", this["_name"]);
        this.addControl("legalName", this["_legalName"]);
        this.addControl("technicalName", this["_technicalName"]);
    }
}
AddPartnerInput.className = "AddPartnerInput";

class UserProfile$1 extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_user"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_createdAt"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_lastConnexionDate"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_optin"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("UserProfile");
        this.addControl("user", this["_user"]);
        this.addControl("createdAt", this["_createdAt"]);
        this.addControl("lastConnexionDate", this["_lastConnexionDate"]);
        this.addControl("name", this["_name"]);
        this.addControl("optin", this["_optin"]);
    }
}
UserProfile$1.className = "UserProfile";

class PartnerUserProfile extends UserProfile$1 {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_user"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_createdAt"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_lastConnexionDate"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_partner"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_email"] = new FormControl(null, Validators.compose([]));
        this["_firstName"] = new FormControl(null, Validators.compose([]));
        this["_lastName"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("PartnerUserProfile");
        this.addControl("user", this["_user"]);
        this.addControl("createdAt", this["_createdAt"]);
        this.addControl("lastConnexionDate", this["_lastConnexionDate"]);
        this.addControl("name", this["_name"]);
        this.addControl("partner", this["_partner"]);
        this.addControl("email", this["_email"]);
        this.addControl("firstName", this["_firstName"]);
        this.addControl("lastName", this["_lastName"]);
    }
}
PartnerUserProfile.className = "PartnerUserProfile";

class ArchivedSurvey extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_company"] = new Company({}, Validators.compose([Validators.required]));
        this["_entity"] = new CompanyEntity$1({}, Validators.compose([Validators.required]));
        this["_archiveDate"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_summarySurvey"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_sectorSurvey"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_sector"] = new CompanySector({}, Validators.compose([Validators.required]));
        this["_selectedActions"] = new FormArrayOf(Action);
        this["_pdfUrl"] = new FormControl(null, Validators.compose([]));
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ArchivedSurvey");
        this.addControl("company", this["_company"]);
        this.addControl("entity", this["_entity"]);
        this.addControl("archiveDate", this["_archiveDate"]);
        this.addControl("summarySurvey", this["_summarySurvey"]);
        this.addControl("sectorSurvey", this["_sectorSurvey"]);
        this.addControl("sector", this["_sector"]);
        this.addControl("selectedActions", this["_selectedActions"]);
        this.addControl("pdfUrl", this["_pdfUrl"]);
        this.addControl("partner", this["_partner"]);
    }
}
ArchivedSurvey.className = "ArchivedSurvey";

class DatavizAnswer extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_archivedSurvey"] = new FormControl(null, Validators.compose([]));
        this["_summaryEndDate"] = new FormDate(null, Validators.compose([]));
        this["_entity"] = new FormControl(null, Validators.compose([]));
        this["_sectorSurvey"] = new FormControl(null, Validators.compose([]));
        this["_summarySurvey"] = new FormControl(null, Validators.compose([]));
        this["_sectorAnswer"] = new FormArrayOf(AnswerValue);
        this["_sectorName"] = new FormControl(null, Validators.compose([]));
        this["_sectorId"] = new FormControl(null, Validators.compose([]));
        this["_action"] = new FormControl(null, Validators.compose([]));
        this["_values"] = new FormControl(null, Validators.compose([]));
        this["_rootTheme"] = new FormControl(null, Validators.compose([]));
        this["_parentTheme"] = new FormControl(null, Validators.compose([]));
        this["_theme"] = new FormControl(null, Validators.compose([]));
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("DatavizAnswer");
        this.addControl("archivedSurvey", this["_archivedSurvey"]);
        this.addControl("summaryEndDate", this["_summaryEndDate"]);
        this.addControl("entity", this["_entity"]);
        this.addControl("sectorSurvey", this["_sectorSurvey"]);
        this.addControl("summarySurvey", this["_summarySurvey"]);
        this.addControl("sectorAnswer", this["_sectorAnswer"]);
        this.addControl("sectorName", this["_sectorName"]);
        this.addControl("sectorId", this["_sectorId"]);
        this.addControl("action", this["_action"]);
        this.addControl("values", this["_values"]);
        this.addControl("rootTheme", this["_rootTheme"]);
        this.addControl("parentTheme", this["_parentTheme"]);
        this.addControl("theme", this["_theme"]);
        this.addControl("partner", this["_partner"]);
    }
}
DatavizAnswer.className = "DatavizAnswer";

class CompanyEntity$1 extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_company"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_sector"] = new FormControl(null, Validators.compose([]));
        this["_completedPercent"] = new FormControl(null, Validators.compose([]));
        this["_summarySurveyId"] = new FormControl(null, Validators.compose([]));
        this["_sectorSurveyId"] = new FormControl(null, Validators.compose([]));
        this["_selectedActions"] = new FormArrayOf(FormControl);
        this["_surveyUpdatedDate"] = new FormDate(null, Validators.compose([]));
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("CompanyEntity");
        this.addControl("name", this["_name"]);
        this.addControl("company", this["_company"]);
        this.addControl("sector", this["_sector"]);
        this.addControl("completedPercent", this["_completedPercent"]);
        this.addControl("summarySurveyId", this["_summarySurveyId"]);
        this.addControl("sectorSurveyId", this["_sectorSurveyId"]);
        this.addControl("selectedActions", this["_selectedActions"]);
        this.addControl("surveyUpdatedDate", this["_surveyUpdatedDate"]);
        this.addControl("partner", this["_partner"]);
    }
    get "_sectorSurveyState"() {
        if (!this.controls["sectorSurveyState"]) {
            let temp = new CompanyEntitySurveyState({}, Validators.compose([]));
            this.addControl("sectorSurveyState", temp);
        }
        return this.controls["sectorSurveyState"];
    }
    set "_sectorSurveyState"(value) {
        if (this["__sectorSurveyState"]) {
            this.removeControl("sectorSurveyState");
        }
        this["__sectorSurveyState"] = value;
        this.addControl("sectorSurveyState", this["__sectorSurveyState"]);
    }
    get "_summarySurveyState"() {
        if (!this.controls["summarySurveyState"]) {
            let temp = new CompanyEntitySummarySurveyState({}, Validators.compose([]));
            this.addControl("summarySurveyState", temp);
        }
        return this.controls["summarySurveyState"];
    }
    set "_summarySurveyState"(value) {
        if (this["__summarySurveyState"]) {
            this.removeControl("summarySurveyState");
        }
        this["__summarySurveyState"] = value;
        this.addControl("summarySurveyState", this["__summarySurveyState"]);
    }
}
CompanyEntity$1.className = "CompanyEntity";

class Contact extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_phone"] = new FormControl(null, Validators.compose([]));
        this["_email"] = new FormControl(null, Validators.compose([]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Contact");
        this.addControl("phone", this["_phone"]);
        this.addControl("email", this["_email"]);
        this.addControl("description", this["_description"]);
    }
    get "_img"() {
        if (!this.controls["img"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("img", temp);
        }
        return this.controls["img"];
    }
    set "_img"(value) {
        if (this["__img"]) {
            this.removeControl("img");
        }
        this["__img"] = value;
        this.addControl("img", this["__img"]);
    }
}
Contact.className = "Contact";

class HeaderBanner extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_subtitle"] = new FormControl(null, Validators.compose([]));
        this["_btnLabel"] = new FormControl(null, Validators.compose([]));
        this["_btnLink"] = new FormControl(null, Validators.compose([]));
        this["_imgOpacity"] = new FormControl(50, Validators.compose([]));
        this.controls._class.setValue("HeaderBanner");
        this.addControl("name", this["_name"]);
        this.addControl("subtitle", this["_subtitle"]);
        this.addControl("btnLabel", this["_btnLabel"]);
        this.addControl("btnLink", this["_btnLink"]);
        this.addControl("imgOpacity", this["_imgOpacity"]);
    }
    get "_img"() {
        if (!this.controls["img"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("img", temp);
        }
        return this.controls["img"];
    }
    set "_img"(value) {
        if (this["__img"]) {
            this.removeControl("img");
        }
        this["__img"] = value;
        this.addControl("img", this["__img"]);
    }
}
HeaderBanner.className = "HeaderBanner";

class MEA2 extends VisualComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("MEA2");
    }
    get "_bloc1"() {
        if (!this.controls["bloc1"]) {
            let temp = new MEA_Block({}, Validators.compose([]));
            this.addControl("bloc1", temp);
        }
        return this.controls["bloc1"];
    }
    set "_bloc1"(value) {
        if (this["__bloc1"]) {
            this.removeControl("bloc1");
        }
        this["__bloc1"] = value;
        this.addControl("bloc1", this["__bloc1"]);
    }
    get "_bloc2"() {
        if (!this.controls["bloc2"]) {
            let temp = new MEA_Block({}, Validators.compose([]));
            this.addControl("bloc2", temp);
        }
        return this.controls["bloc2"];
    }
    set "_bloc2"(value) {
        if (this["__bloc2"]) {
            this.removeControl("bloc2");
        }
        this["__bloc2"] = value;
        this.addControl("bloc2", this["__bloc2"]);
    }
}
MEA2.className = "MEA2";

class MEA3 extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("MEA3");
    }
    get "_bloc1"() {
        if (!this.controls["bloc1"]) {
            let temp = new MEA_Block({}, Validators.compose([]));
            this.addControl("bloc1", temp);
        }
        return this.controls["bloc1"];
    }
    set "_bloc1"(value) {
        if (this["__bloc1"]) {
            this.removeControl("bloc1");
        }
        this["__bloc1"] = value;
        this.addControl("bloc1", this["__bloc1"]);
    }
    get "_bloc2"() {
        if (!this.controls["bloc2"]) {
            let temp = new MEA_Block({}, Validators.compose([]));
            this.addControl("bloc2", temp);
        }
        return this.controls["bloc2"];
    }
    set "_bloc2"(value) {
        if (this["__bloc2"]) {
            this.removeControl("bloc2");
        }
        this["__bloc2"] = value;
        this.addControl("bloc2", this["__bloc2"]);
    }
    get "_bloc3"() {
        if (!this.controls["bloc3"]) {
            let temp = new MEA_Block({}, Validators.compose([]));
            this.addControl("bloc3", temp);
        }
        return this.controls["bloc3"];
    }
    set "_bloc3"(value) {
        if (this["__bloc3"]) {
            this.removeControl("bloc3");
        }
        this["__bloc3"] = value;
        this.addControl("bloc3", this["__bloc3"]);
    }
}
MEA3.className = "MEA3";

class UISynthesisHeaderLocal extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("UISynthesisHeaderLocal");
    }
}
UISynthesisHeaderLocal.className = "UISynthesisHeaderLocal";

class UISynthesisHeaderGlobal extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.controls._class.setValue("UISynthesisHeaderGlobal");
    }
}
UISynthesisHeaderGlobal.className = "UISynthesisHeaderGlobal";

class UIActionSelector extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_titre"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("UIActionSelector");
        this.addControl("titre", this["_titre"]);
    }
}
UIActionSelector.className = "UIActionSelector";

class UIAutoActionSelector extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_nb"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_titre"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("UIAutoActionSelector");
        this.addControl("nb", this["_nb"]);
        this.addControl("titre", this["_titre"]);
    }
}
UIAutoActionSelector.className = "UIAutoActionSelector";

class Company extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_users"] = new FormArrayOf(FormControl);
        this["_logo"] = new FormControl(null, Validators.compose([]));
        this["_siret"] = new FormControl(null, Validators.compose([]));
        this["_contactMail"] = new FormControl(null, Validators.compose([]));
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Company");
        this.addControl("name", this["_name"]);
        this.addControl("users", this["_users"]);
        this.addControl("logo", this["_logo"]);
        this.addControl("siret", this["_siret"]);
        this.addControl("contactMail", this["_contactMail"]);
        this.addControl("partner", this["_partner"]);
    }
    get "_address"() {
        if (!this.controls["address"]) {
            let temp = new address({}, Validators.compose([]));
            this.addControl("address", temp);
        }
        return this.controls["address"];
    }
    set "_address"(value) {
        if (this["__address"]) {
            this.removeControl("address");
        }
        this["__address"] = value;
        this.addControl("address", this["__address"]);
    }
}
Company.className = "Company";

class HtmlPage extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_content"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("HtmlPage");
        this.addControl("name", this["_name"]);
        this.addControl("content", this["_content"]);
    }
}
HtmlPage.className = "HtmlPage";

class SectorSurvey$1 extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_questionsSector"] = new FormArrayOf(FormControl);
        this["_questionsProfile"] = new FormArrayOf(FormControl);
        this["_companySectorMapping"] = new FormArrayOf(CompanySectorSectorSurveyCombinationMapping);
        this["_isDefault"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SectorSurvey");
        this.addControl("name", this["_name"]);
        this.addControl("questionsSector", this["_questionsSector"]);
        this.addControl("questionsProfile", this["_questionsProfile"]);
        this.addControl("companySectorMapping", this["_companySectorMapping"]);
        this.addControl("isDefault", this["_isDefault"]);
    }
}
SectorSurvey$1.className = "SectorSurvey";

class SurveyTheme extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this["_datavizLabel"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SurveyTheme");
        this.addControl("name", this["_name"]);
        this.addControl("description", this["_description"]);
        this.addControl("datavizLabel", this["_datavizLabel"]);
    }
}
SurveyTheme.className = "SurveyTheme";

class SummaryItemOfSurvey extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_themekey"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_description"] = new FormControl(null, Validators.compose([]));
        this["_children"] = new FormArrayOf(SummaryItemOfSurvey);
        this["_action"] = new FormArrayOf(FormControl);
        this["_startPageView"] = new FormControl(null, Validators.compose([]));
        this["_endPageView"] = new FormControl(null, Validators.compose([]));
        this["_didYouKnow"] = new FormControl(null, Validators.compose([]));
        this["_pdfData"] = new DataPdf({}, Validators.compose([Validators.required]));
        this["_icon"] = new FormControl(null, Validators.compose([]));
        this["_baseline"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SummaryItemOfSurvey");
        this.addControl("name", this["_name"]);
        this.addControl("themekey", this["_themekey"]);
        this.addControl("description", this["_description"]);
        this.addControl("children", this["_children"]);
        this.addControl("action", this["_action"]);
        this.addControl("startPageView", this["_startPageView"]);
        this.addControl("endPageView", this["_endPageView"]);
        this.addControl("didYouKnow", this["_didYouKnow"]);
        this.addControl("pdfData", this["_pdfData"]);
        this.addControl("icon", this["_icon"]);
        this.addControl("baseline", this["_baseline"]);
    }
    get "_imageBanner"() {
        if (!this.controls["imageBanner"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("imageBanner", temp);
        }
        return this.controls["imageBanner"];
    }
    set "_imageBanner"(value) {
        if (this["__imageBanner"]) {
            this.removeControl("imageBanner");
        }
        this["__imageBanner"] = value;
        this.addControl("imageBanner", this["__imageBanner"]);
    }
}
SummaryItemOfSurvey.className = "SummaryItemOfSurvey";

class DataVizObjectFilter extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_dataName"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_dataValue"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("DataVizObjectFilter");
        this.addControl("dataName", this["_dataName"]);
        this.addControl("dataValue", this["_dataValue"]);
    }
}
DataVizObjectFilter.className = "DataVizObjectFilter";

class Action extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_isMultiAnswers"] = new FormControl(null, Validators.compose([]));
        this["_question"] = new FormControl(null, Validators.compose([]));
        this["_actionLabel"] = new FormControl(null, Validators.compose([]));
        this["_impact"] = new FormControl(null, Validators.compose([]));
        this["_feasibility"] = new FormControl(null, Validators.compose([]));
        this["_issue"] = new FormControl(null, Validators.compose([]));
        this["_filter"] = new FormArrayOf(ActionSelector);
        this["_didYouKnow"] = new FormControl(null, Validators.compose([]));
        this["_answers"] = new FormArrayOf(FormSectorSurveyAnswer_Number);
        this.controls._class.setValue("Action");
        this.addControl("name", this["_name"]);
        this.addControl("isMultiAnswers", this["_isMultiAnswers"]);
        this.addControl("question", this["_question"]);
        this.addControl("actionLabel", this["_actionLabel"]);
        this.addControl("impact", this["_impact"]);
        this.addControl("feasibility", this["_feasibility"]);
        this.addControl("issue", this["_issue"]);
        this.addControl("filter", this["_filter"]);
        this.addControl("didYouKnow", this["_didYouKnow"]);
        this.addControl("answers", this["_answers"]);
    }
}
Action.className = "Action";

class lostPasswordRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_email"] = new FormControl(null, Validators.compose([]));
        this["_redirectUrl"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("lostPasswordRequest");
        this.addControl("email", this["_email"]);
        this.addControl("redirectUrl", this["_redirectUrl"]);
    }
}
lostPasswordRequest.className = "lostPasswordRequest";

class AdminUserProfile extends UserProfile$1 {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_email"] = new FormControl(null, Validators.compose([]));
        this["_firstName"] = new FormControl(null, Validators.compose([]));
        this["_lastName"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("AdminUserProfile");
        this.addControl("email", this["_email"]);
        this.addControl("firstName", this["_firstName"]);
        this.addControl("lastName", this["_lastName"]);
    }
}
AdminUserProfile.className = "AdminUserProfile";

class Partner extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_legalName"] = new FormControl(null, Validators.compose([]));
        this["_technicalName"] = new FormControl(null, Validators.compose([]));
        this["_creator"] = new FormControl(null, Validators.compose([]));
        this["_landingPageData"] = new FormControl(null, Validators.compose([]));
        this["_clientId"] = new FormControl(null, Validators.compose([]));
        this["_landingPageUrl"] = new FormControl(null, Validators.compose([]));
        this["_adminUrl"] = new FormControl(null, Validators.compose([]));
        this["_creationDate"] = new FormDate(null, Validators.compose([Validators.required]));
        this["_sectorSurvey"] = new FormControl(null, Validators.compose([]));
        this["_contactMail"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("Partner");
        this.addControl("name", this["_name"]);
        this.addControl("legalName", this["_legalName"]);
        this.addControl("technicalName", this["_technicalName"]);
        this.addControl("creator", this["_creator"]);
        this.addControl("landingPageData", this["_landingPageData"]);
        this.addControl("clientId", this["_clientId"]);
        this.addControl("landingPageUrl", this["_landingPageUrl"]);
        this.addControl("adminUrl", this["_adminUrl"]);
        this.addControl("creationDate", this["_creationDate"]);
        this.addControl("sectorSurvey", this["_sectorSurvey"]);
        this.addControl("contactMail", this["_contactMail"]);
    }
    get "_logo"() {
        if (!this.controls["logo"]) {
            let temp = new FsoImage({}, Validators.compose([]));
            this.addControl("logo", temp);
        }
        return this.controls["logo"];
    }
    set "_logo"(value) {
        if (this["__logo"]) {
            this.removeControl("logo");
        }
        this["__logo"] = value;
        this.addControl("logo", this["__logo"]);
    }
}
Partner.className = "Partner";

class DataPdf extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_message1"] = new FormControl(null, Validators.compose([]));
        this["_message2"] = new FormControl(null, Validators.compose([]));
        this["_info25"] = new FormControl(null, Validators.compose([]));
        this["_info50"] = new FormControl(null, Validators.compose([]));
        this["_info75"] = new FormControl(null, Validators.compose([]));
        this["_info100"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("DataPdf");
        this.addControl("message1", this["_message1"]);
        this.addControl("message2", this["_message2"]);
        this.addControl("info25", this["_info25"]);
        this.addControl("info50", this["_info50"]);
        this.addControl("info75", this["_info75"]);
        this.addControl("info100", this["_info100"]);
    }
}
DataPdf.className = "DataPdf";

class DatavizRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_viewName"] = new FormControl(null, Validators.compose([]));
        this["_filter"] = new FormArrayOf(DataVizObjectFilter);
        this["_ids"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("DatavizRequest");
        this.addControl("viewName", this["_viewName"]);
        this.addControl("filter", this["_filter"]);
        this.addControl("ids", this["_ids"]);
    }
}
DatavizRequest.className = "DatavizRequest";

class dataAvg extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_avg"] = new FormControl(null, Validators.compose([]));
        this["_total"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("dataAvg");
        this.addControl("avg", this["_avg"]);
        this.addControl("total", this["_total"]);
    }
}
dataAvg.className = "dataAvg";

class entitiesAverageResutlsBySizeAndThemeResult extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_percent"] = new FormControl(null, Validators.compose([]));
        this["_size"] = new FormControl(null, Validators.compose([]));
        this["_total"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("entitiesAverageResutlsBySizeAndThemeResult");
        this.addControl("percent", this["_percent"]);
        this.addControl("size", this["_size"]);
        this.addControl("total", this["_total"]);
    }
}
entitiesAverageResutlsBySizeAndThemeResult.className = "entitiesAverageResutlsBySizeAndThemeResult";

class CompanyEntityInfo extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_completedPercent"] = new FormControl(null, Validators.compose([]));
        this["_summarySurveyId"] = new FormControl(null, Validators.compose([]));
        this["_sectorSurveyId"] = new FormControl(null, Validators.compose([]));
        this["_surveyUpdatedDate"] = new FormDate(null, Validators.compose([]));
        this["_archiveDate"] = new FormDate(null, Validators.compose([]));
        this["_pdfUrl"] = new FormControl(null, Validators.compose([]));
        this["_companyName"] = new FormControl(null, Validators.compose([]));
        this["_users"] = new FormArrayOf(User);
        this["_userName"] = new FormControl(null, Validators.compose([]));
        this["_mail"] = new FormControl(null, Validators.compose([]));
        this["_creationDate"] = new FormDate(null, Validators.compose([]));
        this.controls._class.setValue("CompanyEntityInfo");
        this.addControl("name", this["_name"]);
        this.addControl("completedPercent", this["_completedPercent"]);
        this.addControl("summarySurveyId", this["_summarySurveyId"]);
        this.addControl("sectorSurveyId", this["_sectorSurveyId"]);
        this.addControl("surveyUpdatedDate", this["_surveyUpdatedDate"]);
        this.addControl("archiveDate", this["_archiveDate"]);
        this.addControl("pdfUrl", this["_pdfUrl"]);
        this.addControl("companyName", this["_companyName"]);
        this.addControl("users", this["_users"]);
        this.addControl("userName", this["_userName"]);
        this.addControl("mail", this["_mail"]);
        this.addControl("creationDate", this["_creationDate"]);
    }
}
CompanyEntityInfo.className = "CompanyEntityInfo";

class CustomerUserProfile extends UserProfile$1 {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this["_email"] = new FormControl(null, Validators.compose([]));
        this["_optinCommercial"] = new FormDate(null, Validators.compose([]));
        this.controls._class.setValue("CustomerUserProfile");
        this.addControl("partner", this["_partner"]);
        this.addControl("email", this["_email"]);
        this.addControl("optinCommercial", this["_optinCommercial"]);
    }
}
CustomerUserProfile.className = "CustomerUserProfile";

class CreateProfileRequest extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_firstName"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_lastName"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_email"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_password"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this["_optin"] = new FormControl(false, Validators.compose([]));
        this["_invitationId"] = new FormControl(null, Validators.compose([]));
        this["_optinCommercial"] = new FormDate(null, Validators.compose([]));
        this["_companyName"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("CreateProfileRequest");
        this.addControl("firstName", this["_firstName"]);
        this.addControl("lastName", this["_lastName"]);
        this.addControl("email", this["_email"]);
        this.addControl("password", this["_password"]);
        this.addControl("partner", this["_partner"]);
        this.addControl("optin", this["_optin"]);
        this.addControl("invitationId", this["_invitationId"]);
        this.addControl("optinCommercial", this["_optinCommercial"]);
        this.addControl("companyName", this["_companyName"]);
    }
}
CreateProfileRequest.className = "CreateProfileRequest";

class ActionCardContent extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_paragraph"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ActionCardContent");
        this.addControl("name", this["_name"]);
        this.addControl("paragraph", this["_paragraph"]);
    }
}
ActionCardContent.className = "ActionCardContent";

class ActionCard extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_action"] = new FormControl(null, Validators.compose([]));
        this["_content"] = new FormArrayOf(ActionCardContent);
        this["_actionReference"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ActionCard");
        this.addControl("name", this["_name"]);
        this.addControl("action", this["_action"]);
        this.addControl("content", this["_content"]);
        this.addControl("actionReference", this["_actionReference"]);
    }
}
ActionCard.className = "ActionCard";

class SummaryItemOfSurveyResult extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_entity"] = new FormControl(null, Validators.compose([]));
        this["_percent"] = new FormControl(null, Validators.compose([]));
        this["_summaryItemOfSurveyId"] = new FormControl(null, Validators.compose([]));
        this["_themekey"] = new FormControl(null, Validators.compose([]));
        this["_summaryItemOfSurveyName"] = new FormControl(null, Validators.compose([]));
        this["_sectorAnswer"] = new FormArrayOf(AnswerValue);
        this["_sectorName"] = new FormControl(null, Validators.compose([]));
        this["_sectorId"] = new FormControl(null, Validators.compose([]));
        this["_summaryEndDate"] = new FormDate(null, Validators.compose([]));
        this["_partner"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("SummaryItemOfSurveyResult");
        this.addControl("entity", this["_entity"]);
        this.addControl("percent", this["_percent"]);
        this.addControl("summaryItemOfSurveyId", this["_summaryItemOfSurveyId"]);
        this.addControl("themekey", this["_themekey"]);
        this.addControl("summaryItemOfSurveyName", this["_summaryItemOfSurveyName"]);
        this.addControl("sectorAnswer", this["_sectorAnswer"]);
        this.addControl("sectorName", this["_sectorName"]);
        this.addControl("sectorId", this["_sectorId"]);
        this.addControl("summaryEndDate", this["_summaryEndDate"]);
        this.addControl("partner", this["_partner"]);
    }
}
SummaryItemOfSurveyResult.className = "SummaryItemOfSurveyResult";

class Footer extends VisualPageComponent {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_title"] = new FormControl(null, Validators.compose([]));
        this["_titleUrl"] = new FormControl(null, Validators.compose([]));
        this["_linkedin"] = new FormControl(null, Validators.compose([]));
        this["_instagram"] = new FormControl(null, Validators.compose([]));
        this["_facebook"] = new FormControl(null, Validators.compose([]));
        this["_youtube"] = new FormControl(null, Validators.compose([]));
        this["_twitter"] = new FormControl(null, Validators.compose([]));
        this["_cgu"] = new FormControl(null, Validators.compose([]));
        this["_legalNotice"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("Footer");
        this.addControl("title", this["_title"]);
        this.addControl("titleUrl", this["_titleUrl"]);
        this.addControl("linkedin", this["_linkedin"]);
        this.addControl("instagram", this["_instagram"]);
        this.addControl("facebook", this["_facebook"]);
        this.addControl("youtube", this["_youtube"]);
        this.addControl("twitter", this["_twitter"]);
        this.addControl("cgu", this["_cgu"]);
        this.addControl("legalNotice", this["_legalNotice"]);
    }
}
Footer.className = "Footer";

class application_configuration extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_services"] = new FormArrayOf(FormControl);
        this["_appName"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("application_configuration");
        this.addControl("name", this["_name"]);
        this.addControl("services", this["_services"]);
        this.addControl("appName", this["_appName"]);
    }
}
application_configuration.className = "application_configuration";

class service$1 extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_name"] = new FormControl(null, Validators.compose([]));
        this["_urlBase"] = new FormControl("$ENV.DOMAINE$$/", Validators.compose([]));
        this["_port"] = new FormControl(null, Validators.compose([]));
        this["_debug"] = new FormControl(true, Validators.compose([]));
        this["_licence_well-known"] = new FormControl("$ENV.WELL_KNOWN", Validators.compose([]));
        this["_secretKey"] = new FormControl("$ENV.SECRET", Validators.compose([]));
        this["_bindIp"] = new FormControl("0.0.0.0", Validators.compose([]));
        this["_headers"] = new FormArrayOf(name_value);
        this["_accessControlAllowOrigin"] = new FormArrayOf(FormControl);
        this["_confServiceUrl"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("service");
        this.addControl("name", this["_name"]);
        this.addControl("urlBase", this["_urlBase"]);
        this.addControl("port", this["_port"]);
        this.addControl("debug", this["_debug"]);
        this.addControl("licence_well-known", this["_licence_well-known"]);
        this.addControl("secretKey", this["_secretKey"]);
        this.addControl("bindIp", this["_bindIp"]);
        this.addControl("headers", this["_headers"]);
        this.addControl("accessControlAllowOrigin", this["_accessControlAllowOrigin"]);
        this.addControl("confServiceUrl", this["_confServiceUrl"]);
    }
    get "_publicAccess"() {
        if (!this.controls["publicAccess"]) {
            let temp = new url_role({}, Validators.compose([]));
            this.addControl("publicAccess", temp);
        }
        return this.controls["publicAccess"];
    }
    set "_publicAccess"(value) {
        if (this["__publicAccess"]) {
            this.removeControl("publicAccess");
        }
        this["__publicAccess"] = value;
        this.addControl("publicAccess", this["__publicAccess"]);
    }
}
service$1.className = "service";

class route_role extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_route"] = new FormControl("/", Validators.compose([]));
        this["_role"] = new FormArrayOf(FormControl);
        this.controls._class.setValue("route_role");
        this.addControl("route", this["_route"]);
        this.addControl("role", this["_role"]);
    }
}
route_role.className = "route_role";

class url_role extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["__$get"] = new FormArrayOf(route_role);
        this["__$post"] = new FormArrayOf(route_role);
        this["__$delete"] = new FormArrayOf(route_role);
        this["__$put"] = new FormArrayOf(route_role);
        this["__$patch"] = new FormArrayOf(route_role);
        this.controls._class.setValue("url_role");
        this.addControl("_$get", this["__$get"]);
        this.addControl("_$post", this["__$post"]);
        this.addControl("_$delete", this["__$delete"]);
        this.addControl("_$put", this["__$put"]);
        this.addControl("_$patch", this["__$patch"]);
    }
}
url_role.className = "url_role";

class name_value extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_key"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_value"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("name_value");
        this.addControl("key", this["_key"]);
        this.addControl("value", this["_value"]);
    }
}
name_value.className = "name_value";

class application_configuration_r3_admin extends application_configuration {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_bddUrl"] = new FormControl(null, Validators.compose([]));
        this["_uploadUrl"] = new FormControl(null, Validators.compose([]));
        this["_apiUrl"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("application_configuration_r3_admin");
        this.addControl("bddUrl", this["_bddUrl"]);
        this.addControl("uploadUrl", this["_uploadUrl"]);
        this.addControl("apiUrl", this["_apiUrl"]);
    }
}
application_configuration_r3_admin.className = "application_configuration_r3_admin";

class application_configuration_r3_admin_seller extends application_configuration {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_bddUrl"] = new FormControl(null, Validators.compose([]));
        this["_apiUrl"] = new FormControl(null, Validators.compose([]));
        this["_fsoUrl"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("application_configuration_r3_admin_seller");
        this.addControl("bddUrl", this["_bddUrl"]);
        this.addControl("apiUrl", this["_apiUrl"]);
        this.addControl("fsoUrl", this["_fsoUrl"]);
    }
}
application_configuration_r3_admin_seller.className = "application_configuration_r3_admin_seller";

class application_configuration_r3 extends application_configuration {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_bddUrl"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("application_configuration_r3");
        this.addControl("bddUrl", this["_bddUrl"]);
    }
}
application_configuration_r3.className = "application_configuration_r3";

class r3_service extends service$1 {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_bddUrl"] = new FormControl(null, Validators.compose([]));
        this["_ssoBddUrl"] = new FormControl(null, Validators.compose([]));
        this["_infraBddUrl"] = new FormControl(null, Validators.compose([]));
        this["_ssoApiUrl"] = new FormControl(null, Validators.compose([]));
        this["_licenceApiUrl"] = new FormControl(null, Validators.compose([]));
        this["_client_id"] = new FormControl(null, Validators.compose([]));
        this["_client_secret"] = new FormControl(null, Validators.compose([]));
        this["_pdfRipUrl"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_pdfAppUrl"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_fsoUrl"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_authorizedDomaine"] = new FormArrayOf(FormControl);
        this["_adminSiteUrl"] = new FormControl(null, Validators.compose([Validators.required]));
        this.controls._class.setValue("r3_service");
        this.addControl("bddUrl", this["_bddUrl"]);
        this.addControl("ssoBddUrl", this["_ssoBddUrl"]);
        this.addControl("infraBddUrl", this["_infraBddUrl"]);
        this.addControl("ssoApiUrl", this["_ssoApiUrl"]);
        this.addControl("licenceApiUrl", this["_licenceApiUrl"]);
        this.addControl("client_id", this["_client_id"]);
        this.addControl("client_secret", this["_client_secret"]);
        this.addControl("pdfRipUrl", this["_pdfRipUrl"]);
        this.addControl("pdfAppUrl", this["_pdfAppUrl"]);
        this.addControl("fsoUrl", this["_fsoUrl"]);
        this.addControl("authorizedDomaine", this["_authorizedDomaine"]);
        this.addControl("adminSiteUrl", this["_adminSiteUrl"]);
    }
    get "_SendGridConf"() {
        if (!this.controls["SendGridConf"]) {
            let temp = new R3Mailer({}, Validators.compose([]));
            this.addControl("SendGridConf", temp);
        }
        return this.controls["SendGridConf"];
    }
    set "_SendGridConf"(value) {
        if (this["__SendGridConf"]) {
            this.removeControl("SendGridConf");
        }
        this["__SendGridConf"] = value;
        this.addControl("SendGridConf", this["__SendGridConf"]);
    }
    get "_parntaireConfig"() {
        if (!this.controls["parntaireConfig"]) {
            let temp = new ParnerDeployConf({}, Validators.compose([]));
            this.addControl("parntaireConfig", temp);
        }
        return this.controls["parntaireConfig"];
    }
    set "_parntaireConfig"(value) {
        if (this["__parntaireConfig"]) {
            this.removeControl("parntaireConfig");
        }
        this["__parntaireConfig"] = value;
        this.addControl("parntaireConfig", this["__parntaireConfig"]);
    }
}
r3_service.className = "r3_service";

class R3Mailer extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_senderEMail"] = new FormControl(null, Validators.compose([]));
        this["_senderName"] = new FormControl(null, Validators.compose([]));
        this["_r3BaseUrl"] = new FormControl(null, Validators.compose([]));
        this["_r3SendgridApiUrl"] = new FormControl(null, Validators.compose([]));
        this["_r3ContactMail"] = new FormControl(null, Validators.compose([]));
        this["_r3_group_resset_password"] = new FormControl(null, Validators.compose([]));
        this["_r3_group_welcome"] = new FormControl(null, Validators.compose([]));
        this["_r3_contact_to_user"] = new FormControl(null, Validators.compose([]));
        this["_r3_contact_to_r3"] = new FormControl(null, Validators.compose([]));
        this["_R3_prescriptor_invitation"] = new FormControl(null, Validators.compose([]));
        this["_R3_analisys_end_to_r3_and_partner"] = new FormControl(null, Validators.compose([]));
        this["_R3_analisys_end_to_user"] = new FormControl(null, Validators.compose([]));
        this["_R3_partner_admin_created"] = new FormControl(null, Validators.compose([]));
        this["_r3_group_welcome_admin_templateId"] = new FormControl(null, Validators.compose([Validators.required]));
        this["_r3_group_welcomeError_templateId"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("R3Mailer");
        this.addControl("senderEMail", this["_senderEMail"]);
        this.addControl("senderName", this["_senderName"]);
        this.addControl("r3BaseUrl", this["_r3BaseUrl"]);
        this.addControl("r3SendgridApiUrl", this["_r3SendgridApiUrl"]);
        this.addControl("r3ContactMail", this["_r3ContactMail"]);
        this.addControl("r3_group_resset_password", this["_r3_group_resset_password"]);
        this.addControl("r3_group_welcome", this["_r3_group_welcome"]);
        this.addControl("r3_contact_to_user", this["_r3_contact_to_user"]);
        this.addControl("r3_contact_to_r3", this["_r3_contact_to_r3"]);
        this.addControl("R3_prescriptor_invitation", this["_R3_prescriptor_invitation"]);
        this.addControl("R3_analisys_end_to_r3_and_partner", this["_R3_analisys_end_to_r3_and_partner"]);
        this.addControl("R3_analisys_end_to_user", this["_R3_analisys_end_to_user"]);
        this.addControl("R3_partner_admin_created", this["_R3_partner_admin_created"]);
        this.addControl("r3_group_welcome_admin_templateId", this["_r3_group_welcome_admin_templateId"]);
        this.addControl("r3_group_welcomeError_templateId", this["_r3_group_welcomeError_templateId"]);
    }
}
R3Mailer.className = "R3Mailer";

class ParnerDeployConf extends FormControlBase {
    constructor(controls = {}, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this["_adminUrl"] = new FormControl(null, Validators.compose([]));
        this["_landingPageUrl"] = new FormControl(null, Validators.compose([]));
        this["_appClientTemplateId"] = new FormControl(null, Validators.compose([]));
        this["_appAdminTemplateId"] = new FormControl(null, Validators.compose([]));
        this["_endClientTemplateId"] = new FormControl(null, Validators.compose([]));
        this["_oidcTemplateId"] = new FormControl(null, Validators.compose([]));
        this.controls._class.setValue("ParnerDeployConf");
        this.addControl("adminUrl", this["_adminUrl"]);
        this.addControl("landingPageUrl", this["_landingPageUrl"]);
        this.addControl("appClientTemplateId", this["_appClientTemplateId"]);
        this.addControl("appAdminTemplateId", this["_appAdminTemplateId"]);
        this.addControl("endClientTemplateId", this["_endClientTemplateId"]);
        this.addControl("oidcTemplateId", this["_oidcTemplateId"]);
    }
}
ParnerDeployConf.className = "ParnerDeployConf";

var formObj_module = /*#__PURE__*/_mergeNamespaces({
    __proto__: null,
    modelid: modelid,
    Field_boolean: Field_boolean,
    Field_date: Field_date,
    Field_texte: Field_texte,
    Field_password: Field_password,
    Field_number: Field_number,
    Field_objectid: Field_objectid,
    Field_string: Field_string,
    Field_htmltexte: Field_htmltexte,
    Field_object: Field_object,
    castParam: castParam,
    routeParam: routeParam,
    subdoc: subdoc,
    SwaggerApi: SwaggerApi,
    SwaggerPath: SwaggerPath,
    _view_params: _view_params,
    field: field,
    SwaggerParams: SwaggerParams,
    _view: _view,
    FormSectorSurveyAnswer: FormSectorSurveyAnswer,
    FormSectorSurveyAnswer_Number: FormSectorSurveyAnswer_Number,
    FormSectorSurveyAnswer_String: FormSectorSurveyAnswer_String,
    ShareClass: ShareClass,
    Issue: Issue,
    protoschema: protoschema,
    Space: Space,
    CompanySector: CompanySector,
    FormSectorSurvey_String: FormSectorSurvey_String,
    FormSectorSurvey_Number: FormSectorSurvey_Number,
    User: User,
    SigninRequest: SigninRequest,
    SigninResponse: SigninResponse,
    FormSectorSurveyUserAnswer: FormSectorSurveyUserAnswer,
    resetPasswordRequest: resetPasswordRequest,
    AnswerValue: AnswerValue,
    AnswerValue_String: AnswerValue_String,
    AnswerValue_Number: AnswerValue_Number,
    CompanySectorSectorSurveyCombinationMapping: CompanySectorSectorSurveyCombinationMapping,
    FsoImage: FsoImage,
    SpaceLabelOfIssue: SpaceLabelOfIssue,
    ContentItem: ContentItem,
    ContentItem_TextRIgth_Picture_Left: ContentItem_TextRIgth_Picture_Left,
    ContentItem_TextLeft_Picture_Rigth: ContentItem_TextLeft_Picture_Rigth,
    Content: Content$1,
    SummaryCompletion: SummaryCompletion,
    CompanyEntitySummarySurveyState: CompanyEntitySummarySurveyState,
    File: File,
    _acl: _acl,
    aclIdentity: aclIdentity,
    CompanyEntitySurveyState: CompanyEntitySurveyState,
    ComputeData: ComputeData,
    SummarySurveyComputation: SummarySurveyComputation,
    ComputeActionData: ComputeActionData,
    ActionSelector: ActionSelector,
    ActionSelector_String: ActionSelector_String,
    UpdateCompanyEntityStatesRequiredAnswers: UpdateCompanyEntityStatesRequiredAnswers,
    ActionSelector_Sector: ActionSelector_Sector,
    ActionSelector_And: ActionSelector_And,
    ActionSelector_Or: ActionSelector_Or,
    ActionSelector_Number: ActionSelector_Number,
    SummarySurveyFilterRequest: SummarySurveyFilterRequest,
    PatchSelectedAction: PatchSelectedAction,
    ContactResponse: ContactResponse,
    generatePdfRequest: generatePdfRequest,
    VisualComponent: VisualComponent,
    MEA_Block: MEA_Block,
    VisualPageComponent: VisualPageComponent,
    LandingPage: LandingPage,
    Invitation: Invitation,
    FormSectorSurvey: FormSectorSurvey,
    MultipleInvitationRequest: MultipleInvitationRequest,
    ImgSideBySide: ImgSideBySide,
    TitreSousTitre: TitreSousTitre,
    SummarySynthesisPage: SummarySynthesisPage,
    SummaryIntroductionPage: SummaryIntroductionPage,
    Button: Button,
    CallToAction: CallToAction,
    MEA_Block_Text: MEA_Block_Text,
    MEA_Block_Image: MEA_Block_Image,
    MEA_Block_Icon: MEA_Block_Icon,
    UIThemeSummary: UIThemeSummary,
    UISynthesisThemeList: UISynthesisThemeList,
    UITitleSubtitle: UITitleSubtitle,
    UISurveyTime: UISurveyTime,
    UIMEA2: UIMEA2,
    CsvRequest: CsvRequest,
    PatchSelectedActions: PatchSelectedActions,
    address: address,
    RoadmapPage: RoadmapPage,
    SummarySurvey: SummarySurvey$1,
    ContactRequest: ContactRequest,
    AnswerValueName: AnswerValueName,
    AnswerValueName_String: AnswerValueName_String,
    AnswerValueName_Number: AnswerValueName_Number,
    DatavizResponse: DatavizResponse,
    RouterProxy: RouterProxy,
    DatavizAnswerByAction: DatavizAnswerByAction,
    AddPartnerInput: AddPartnerInput,
    PartnerUserProfile: PartnerUserProfile,
    ArchivedSurvey: ArchivedSurvey,
    DatavizAnswer: DatavizAnswer,
    CompanyEntity: CompanyEntity$1,
    UserProfile: UserProfile$1,
    Contact: Contact,
    HeaderBanner: HeaderBanner,
    MEA2: MEA2,
    MEA3: MEA3,
    UISynthesisHeaderLocal: UISynthesisHeaderLocal,
    UISynthesisHeaderGlobal: UISynthesisHeaderGlobal,
    UIActionSelector: UIActionSelector,
    UIAutoActionSelector: UIAutoActionSelector,
    Company: Company,
    HtmlPage: HtmlPage,
    SectorSurvey: SectorSurvey$1,
    SurveyTheme: SurveyTheme,
    SummaryItemOfSurvey: SummaryItemOfSurvey,
    DataVizObjectFilter: DataVizObjectFilter,
    Action: Action,
    lostPasswordRequest: lostPasswordRequest,
    AdminUserProfile: AdminUserProfile,
    Partner: Partner,
    DataPdf: DataPdf,
    DatavizRequest: DatavizRequest,
    dataAvg: dataAvg,
    entitiesAverageResutlsBySizeAndThemeResult: entitiesAverageResutlsBySizeAndThemeResult,
    CompanyEntityInfo: CompanyEntityInfo,
    CustomerUserProfile: CustomerUserProfile,
    CreateProfileRequest: CreateProfileRequest,
    ActionCardContent: ActionCardContent,
    ActionCard: ActionCard,
    SummaryItemOfSurveyResult: SummaryItemOfSurveyResult,
    Footer: Footer,
    application_configuration: application_configuration,
    service: service$1,
    route_role: route_role,
    url_role: url_role,
    name_value: name_value,
    application_configuration_r3_admin: application_configuration_r3_admin,
    application_configuration_r3_admin_seller: application_configuration_r3_admin_seller,
    application_configuration_r3: application_configuration_r3,
    r3_service: r3_service,
    R3Mailer: R3Mailer,
    ParnerDeployConf: ParnerDeployConf
}, [common_ng]);

class api_collection_plateform {
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
        /**
         service d'accès à la collection :SwaggerApi
         desc: api définie par swagger
         

         
        */
        this.SwaggerApi = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :_view
         desc: créer des pipe d'agrégation intérogeable https://docs.mongodb.com/manual/reference/operator/aggregation-pipeline/
         
         info: vous pouvez voir tous les objets de cette collection y compris les enfants
         liste des interfaces héritées possibles:
         
            I_view_params      view avec des params
         
         
        */
        this._view = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :_view_params
        desc: view avec des params
        info: vous ne pouvez voir que ce type d'objet
       */
        this._view_params = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :ShareClass
         desc: catégorie d'action
         

         
        */
        this.ShareClass = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :Issue
         desc: enjeux
         

         
        */
        this.Issue = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :protoschema
         desc: protoschema est un méta modéle. il permet de créer les autres modèle de la base
         

         
        */
        this.protoschema = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :Space
         desc: espace de donnée donné
         

         
        */
        this.Space = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :CompanySector
         desc: Secteur d'activité d'une entreprise
         

         
        */
        this.CompanySector = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :User
         desc: Comptes utilisateur pour authentification sur l'application.
         

         
        */
        this.User = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :FsoImage
         desc: Schema pour l'upload d'images
         

         
        */
        this.FsoImage = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :Content
         desc: classe avec le contenu pour les donnes html a affiche avant et apres les questions, aussi pour les intro
         

         
        */
        this.Content = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SummaryCompletion
         desc: état d avancement d'un summary survey
         

         
        */
        this.SummaryCompletion = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :File
         desc: Multer files object
         

         
        */
        this.File = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :LandingPage
         desc: Landing page pour un partenaire
         

         
        */
        this.LandingPage = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :Invitation
         desc: Represente une invitation a realiser un rapport rse sur le site d'un partenaire R3
         

         
        */
        this.Invitation = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :FormSectorSurvey
         desc: question d'une enquête pour déterminer le secteur d'activité de la société ou définir son profile
         
         info: vous pouvez voir tous les objets de cette collection y compris les enfants
         liste des interfaces héritées possibles:
         
            IFormSectorSurvey_String      représente un formulaire qui génère une réponse au format string
         
            IFormSectorSurvey_Number      représente un formulaire qui génère une réponse au format number
         
         
        */
        this.FormSectorSurvey = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :FormSectorSurvey_String
        desc: représente un formulaire qui génère une réponse au format string
        info: vous ne pouvez voir que ce type d'objet
       */
        this.FormSectorSurvey_String = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :FormSectorSurvey_Number
        desc: représente un formulaire qui génère une réponse au format number
        info: vous ne pouvez voir que ce type d'objet
       */
        this.FormSectorSurvey_Number = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :MultipleInvitationRequest
         desc: object qui permet de poster plusieur invitations
         

         
        */
        this.MultipleInvitationRequest = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SummarySynthesisPage
         desc: page de synthèse d'un questionnaire
         

         
        */
        this.SummarySynthesisPage = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SummaryIntroductionPage
         desc: page d'introduction d'un questionnaire
         

         
        */
        this.SummaryIntroductionPage = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :RoadmapPage
         desc: page final
         

         
        */
        this.RoadmapPage = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SummarySurvey
         desc: sommaire du questionnaire
         

         
        */
        this.SummarySurvey = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :ContactRequest
         desc: donnes pour le mail de contact a r3
         

         
        */
        this.ContactRequest = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :RouterProxy
         desc: sert de tampon pour les requêtes qui ne doivent être jouer qu'une fois. ou trop longue
         

         
        */
        this.RouterProxy = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :DatavizAnswerByAction
         desc: object de response des dataviz answer filtre par taille de societe
         

         
        */
        this.DatavizAnswerByAction = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :ArchivedSurvey
         desc: Liste des archives sur les informations  des SummarySurvey
         

         
        */
        this.ArchivedSurvey = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :DatavizAnswer
         desc: enregistrement a plat des réponses de la au archivSurvey
         

         
        */
        this.DatavizAnswer = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :CompanyEntity
         desc: profile de l'entité de la société
         

         
        */
        this.CompanyEntity = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :UserProfile
         desc: profile des utilisateurs
         
         info: vous pouvez voir tous les objets de cette collection y compris les enfants
         liste des interfaces héritées possibles:
         
            IPartnerUserProfile      profile des utilisateurs d un partenaire
         
            IAdminUserProfile      profile des utilisateurs admin
         
            ICustomerUserProfile      profile des utilisateurs
         
         
        */
        this.UserProfile = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :PartnerUserProfile
        desc: profile des utilisateurs d un partenaire
        info: vous ne pouvez voir que ce type d'objet
       */
        this.PartnerUserProfile = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :AdminUserProfile
        desc: profile des utilisateurs admin
        info: vous ne pouvez voir que ce type d'objet
       */
        this.AdminUserProfile = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :CustomerUserProfile
        desc: profile des utilisateurs
        info: vous ne pouvez voir que ce type d'objet
       */
        this.CustomerUserProfile = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :Company
         desc: profile de la société
         

         
        */
        this.Company = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :HtmlPage
         desc: Page basique pour la saisie de page type mention légale et conditions générales
         

         
        */
        this.HtmlPage = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SectorSurvey
         desc: questionnaire qui a pour but de déterminer le secteur de l'entreprise, ainsi que sont profile(ex:nombre d'employé, propriétaire de ses locaux .....)
         

         
        */
        this.SectorSurvey = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SurveyTheme
         desc: theme associe a un summaryItemOfsurver
         

         
        */
        this.SurveyTheme = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SummaryItemOfSurvey
         desc: item d'un sommaire
         

         
        */
        this.SummaryItemOfSurvey = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :Action
         desc: action a mener
         

         
        */
        this.Action = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :Partner
         desc: Partenaire r3
         

         
        */
        this.Partner = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :DataPdf
         desc: donnée suplémentaire pour générer le pdf
         

         
        */
        this.DataPdf = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :dataAvg
         desc: dataAvg
         

         
        */
        this.dataAvg = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :entitiesAverageResutlsBySizeAndThemeResult
         desc: entitiesAverageResutlsBySizeAndThemeResult
         

         
        */
        this.entitiesAverageResutlsBySizeAndThemeResult = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :CompanyEntityInfo
         desc: profile de l'entité de la société avec les info users, company name , date d archive url pdf
         

         
        */
        this.CompanyEntityInfo = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :ActionCard
         desc: fiche action
         

         
        */
        this.ActionCard = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :SummaryItemOfSurveyResult
         desc: entity: id de l'entité auquel appartient ce résultat, percent: pourcentage calcule, summaryItemOfSurveyId: id de litem dans le sommaire duquel proviennent les responses, themekey: Id du theme pour les données de ,statistiques, ummaryItemOfSurveyName: Eco-conception
         

         
        */
        this.SummaryItemOfSurveyResult = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :application_configuration
         desc: c'est la configuration d'une application
         
         info: vous pouvez voir tous les objets de cette collection y compris les enfants
         liste des interfaces héritées possibles:
         
            Iapplication_configuration_r3_admin      config r3 admin
         
            Iapplication_configuration_r3_admin_seller      config r3 admin
         
            Iapplication_configuration_r3      config r3
         
         
        */
        this.application_configuration = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :application_configuration_r3_admin
        desc: config r3 admin
        info: vous ne pouvez voir que ce type d'objet
       */
        this.application_configuration_r3_admin = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :application_configuration_r3_admin_seller
        desc: config r3 admin
        info: vous ne pouvez voir que ce type d'objet
       */
        this.application_configuration_r3_admin_seller = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :application_configuration_r3
        desc: config r3
        info: vous ne pouvez voir que ce type d'objet
       */
        this.application_configuration_r3 = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
         service d'accès à la collection :service
         desc: identification du service
         
         info: vous pouvez voir tous les objets de cette collection y compris les enfants
         liste des interfaces héritées possibles:
         
            Ir3_service      service métier de QBP
         
         
        */
        this.service = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        service d'accès a la sous-collection :r3_service
        desc: service métier de QBP
        info: vous ne pouvez voir que ce type d'objet
       */
        this.r3_service = new HttpServiceBase(this.http, this.secure, this.cached, this.useLocalToken);
    }
}
/**
    accès à la vue :allCompanys
    liste des toutes le companies
*/
class api_view_allCompanys extends HttpViewServiceBase {
    /**
        accès à la vue :allCompanys
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue allCompanys
    
    */
    get(query = '*', options = {}) {
        return this.getBase(query, options);
    }
}
/**
    accès à la vue :entitiesGlobalAverageResults
    envoie la moyene des reponses au theme global MATURITE_RSE et FACTEURS_CLES_DE_SUCCES
*/
class api_view_entitiesGlobalAverageResults extends HttpViewServiceBase {
    /**
        accès à la vue :entitiesGlobalAverageResults
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue entitiesGlobalAverageResults
    
    */
    get(answerId, query = '*', options = {}) {
        return this.getBase(answerId.toString() + "/" + query, options);
    }
}
/**
    accès à la vue :datavizAnswerByAction
    groupre les responses par action
*/
class api_view_datavizAnswerByAction extends HttpViewServiceBase {
    /**
        accès à la vue :datavizAnswerByAction
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue datavizAnswerByAction
    
    */
    get(query = '*', options = {}) {
        return this.getBase(query, options);
    }
}
/**
    accès à la vue :datavizAnswerSummarySurveyByParentTheme
    groupre les responses du summary par Theme
*/
class api_view_datavizAnswerSummarySurveyByParentTheme extends HttpViewServiceBase {
    /**
        accès à la vue :datavizAnswerSummarySurveyByParentTheme
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue datavizAnswerSummarySurveyByParentTheme
    
    */
    get(query = '*', options = {}) {
        return this.getBase(query, options);
    }
}
/**
    accès à la vue :barometreRseFIlter
    filtres les donnes du barometre RSE par question
*/
class api_view_barometreRseFIlter extends HttpViewServiceBase {
    /**
        accès à la vue :barometreRseFIlter
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue barometreRseFIlter
    
    */
    get(query = '*', options = {}) {
        return this.getBase(query, options);
    }
}
/**
    accès à la vue :allActionsforParentThemeByValue
    allActionsforParentThemeByValue
*/
class api_view_allActionsforParentThemeByValue extends HttpViewServiceBase {
    /**
        accès à la vue :allActionsforParentThemeByValue
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue allActionsforParentThemeByValue
    
    */
    get(query = '*', options = {}) {
        return this.getBase(query, options);
    }
}
/**
    accès à la vue :summarysurveyTree
    renvoie  summary survey donné mais que avec les noms
*/
class api_view_summarysurveyTree extends HttpViewServiceBase {
    /**
        accès à la vue :summarysurveyTree
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue summarysurveyTree
    
    */
    get(query = '*', options = {}) {
        return this.getBase(query, options);
    }
}
/**
    accès à la vue :datavizAnswerByActionFiltered
    génére une requette sur la vue datavizAnswerByActionFiltered
*/
class api_view_datavizAnswerByActionFiltered extends HttpViewServiceBase {
    /**
        accès à la vue :datavizAnswerByActionFiltered
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue datavizAnswerByActionFiltered
    
    */
    get(query = '*', options = {}) {
        return this.getBase(query, options);
    }
}
/**
    accès à la vue :entitiesAverageResutlsBySizeAndTheme
    envoie la moyene des reponses par taille
*/
class api_view_entitiesAverageResutlsBySizeAndTheme extends HttpViewServiceBase {
    /**
        accès à la vue :entitiesAverageResutlsBySizeAndTheme
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue entitiesAverageResutlsBySizeAndTheme
    
    */
    get(sectorAnswerId, query = '*', options = {}) {
        return this.getBase(sectorAnswerId.toString() + "/" + query, options);
    }
}
/**
    accès à la vue :avgAnswer
    mayen des reponse par action goupé par taille
*/
class api_view_avgAnswer extends HttpViewServiceBase {
    /**
        accès à la vue :avgAnswer
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue avgAnswer
    
    */
    get(sectorAnswerId, query = '*', options = {}) {
        return this.getBase(sectorAnswerId.toString() + "/" + query, options);
    }
}
/**
    accès à la vue :allCompanysFormCompletedSectorAnswers
    classment de entity par raport aux  response du secteur
*/
class api_view_allCompanysFormCompletedSectorAnswers extends HttpViewServiceBase {
    /**
        accès à la vue :allCompanysFormCompletedSectorAnswers
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue allCompanysFormCompletedSectorAnswers
    
    */
    get(answerId, query = '*', options = {}) {
        return this.getBase(answerId.toString() + "/" + query, options);
    }
}
/**
    accès à la vue :nbAnswerActionByAnswer
    nombre de réponse  par  valeur de réponse
*/
class api_view_nbAnswerActionByAnswer extends HttpViewServiceBase {
    /**
        accès à la vue :nbAnswerActionByAnswer
        
    */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    /**
    génére une requette sur la vue nbAnswerActionByAnswer
    
    */
    get(actionId, query = '*', options = {}) {
        return this.getBase(actionId.toString() + "/" + query, options);
    }
}
class api_view_plateform {
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
        /**
        accès à la vue :allCompanys     liste des toutes le companies
        */
        this.allCompanys = new api_view_allCompanys(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :entitiesGlobalAverageResults     envoie la moyene des reponses au theme global MATURITE_RSE et FACTEURS_CLES_DE_SUCCES
        */
        this.entitiesGlobalAverageResults = new api_view_entitiesGlobalAverageResults(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :datavizAnswerByAction     groupre les responses par action
        */
        this.datavizAnswerByAction = new api_view_datavizAnswerByAction(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :datavizAnswerSummarySurveyByParentTheme     groupre les responses du summary par Theme
        */
        this.datavizAnswerSummarySurveyByParentTheme = new api_view_datavizAnswerSummarySurveyByParentTheme(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :barometreRseFIlter     filtres les donnes du barometre RSE par question
        */
        this.barometreRseFIlter = new api_view_barometreRseFIlter(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :allActionsforParentThemeByValue     allActionsforParentThemeByValue
        */
        this.allActionsforParentThemeByValue = new api_view_allActionsforParentThemeByValue(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :summarysurveyTree     renvoie  summary survey donné mais que avec les noms
        */
        this.summarysurveyTree = new api_view_summarysurveyTree(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :datavizAnswerByActionFiltered     génére une requette sur la vue datavizAnswerByActionFiltered
        */
        this.datavizAnswerByActionFiltered = new api_view_datavizAnswerByActionFiltered(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :entitiesAverageResutlsBySizeAndTheme     envoie la moyene des reponses par taille
        */
        this.entitiesAverageResutlsBySizeAndTheme = new api_view_entitiesAverageResutlsBySizeAndTheme(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :avgAnswer     mayen des reponse par action goupé par taille
        */
        this.avgAnswer = new api_view_avgAnswer(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :allCompanysFormCompletedSectorAnswers     classment de entity par raport aux  response du secteur
        */
        this.allCompanysFormCompletedSectorAnswers = new api_view_allCompanysFormCompletedSectorAnswers(this.http, this.secure, this.cached, this.useLocalToken);
        /**
        accès à la vue :nbAnswerActionByAnswer     nombre de réponse  par  valeur de réponse
        */
        this.nbAnswerActionByAnswer = new api_view_nbAnswerActionByAnswer(this.http, this.secure, this.cached, this.useLocalToken);
    }
}
class Api_plateforme {
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
        this.url = '';
        this.collections = new api_collection_plateform(this.http, this.secure, this.cached, this.useLocalToken);
        this.views = new api_view_plateform(this.http, this.secure, this.cached, this.useLocalToken);
    }
    /**
    url de l'api
    */
    get urlApi() {
        return this.url;
    }
    set urlApi(value) {
        if (this.url != value) {
            this.url = value;
            this.init();
        }
    }
    init() {
        this.collections.SwaggerApi.urlCollection = this.url + "collection/SwaggerApi/";
        this.collections._view.urlCollection = this.url + "collection/_view/";
        this.collections._view_params.urlCollection = this.url + "collection/_view_params/";
        this.collections.ShareClass.urlCollection = this.url + "collection/ShareClass/";
        this.collections.Issue.urlCollection = this.url + "collection/Issue/";
        this.collections.protoschema.urlCollection = this.url + "collection/protoschema/";
        this.collections.Space.urlCollection = this.url + "collection/Space/";
        this.collections.CompanySector.urlCollection = this.url + "collection/CompanySector/";
        this.collections.User.urlCollection = this.url + "collection/User/";
        this.collections.FsoImage.urlCollection = this.url + "collection/FsoImage/";
        this.collections.Content.urlCollection = this.url + "collection/Content/";
        this.collections.SummaryCompletion.urlCollection = this.url + "collection/SummaryCompletion/";
        this.collections.File.urlCollection = this.url + "collection/File/";
        this.collections.LandingPage.urlCollection = this.url + "collection/LandingPage/";
        this.collections.Invitation.urlCollection = this.url + "collection/Invitation/";
        this.collections.FormSectorSurvey.urlCollection = this.url + "collection/FormSectorSurvey/";
        this.collections.FormSectorSurvey_String.urlCollection = this.url + "collection/FormSectorSurvey_String/";
        this.collections.FormSectorSurvey_Number.urlCollection = this.url + "collection/FormSectorSurvey_Number/";
        this.collections.MultipleInvitationRequest.urlCollection = this.url + "collection/MultipleInvitationRequest/";
        this.collections.SummarySynthesisPage.urlCollection = this.url + "collection/SummarySynthesisPage/";
        this.collections.SummaryIntroductionPage.urlCollection = this.url + "collection/SummaryIntroductionPage/";
        this.collections.RoadmapPage.urlCollection = this.url + "collection/RoadmapPage/";
        this.collections.SummarySurvey.urlCollection = this.url + "collection/SummarySurvey/";
        this.collections.ContactRequest.urlCollection = this.url + "collection/ContactRequest/";
        this.collections.RouterProxy.urlCollection = this.url + "collection/RouterProxy/";
        this.collections.DatavizAnswerByAction.urlCollection = this.url + "collection/DatavizAnswerByAction/";
        this.collections.ArchivedSurvey.urlCollection = this.url + "collection/ArchivedSurvey/";
        this.collections.DatavizAnswer.urlCollection = this.url + "collection/DatavizAnswer/";
        this.collections.CompanyEntity.urlCollection = this.url + "collection/CompanyEntity/";
        this.collections.UserProfile.urlCollection = this.url + "collection/UserProfile/";
        this.collections.PartnerUserProfile.urlCollection = this.url + "collection/PartnerUserProfile/";
        this.collections.AdminUserProfile.urlCollection = this.url + "collection/AdminUserProfile/";
        this.collections.CustomerUserProfile.urlCollection = this.url + "collection/CustomerUserProfile/";
        this.collections.Company.urlCollection = this.url + "collection/Company/";
        this.collections.HtmlPage.urlCollection = this.url + "collection/HtmlPage/";
        this.collections.SectorSurvey.urlCollection = this.url + "collection/SectorSurvey/";
        this.collections.SurveyTheme.urlCollection = this.url + "collection/SurveyTheme/";
        this.collections.SummaryItemOfSurvey.urlCollection = this.url + "collection/SummaryItemOfSurvey/";
        this.collections.Action.urlCollection = this.url + "collection/Action/";
        this.collections.Partner.urlCollection = this.url + "collection/Partner/";
        this.collections.DataPdf.urlCollection = this.url + "collection/DataPdf/";
        this.collections.dataAvg.urlCollection = this.url + "collection/dataAvg/";
        this.collections.entitiesAverageResutlsBySizeAndThemeResult.urlCollection = this.url + "collection/entitiesAverageResutlsBySizeAndThemeResult/";
        this.collections.CompanyEntityInfo.urlCollection = this.url + "collection/CompanyEntityInfo/";
        this.collections.ActionCard.urlCollection = this.url + "collection/ActionCard/";
        this.collections.SummaryItemOfSurveyResult.urlCollection = this.url + "collection/SummaryItemOfSurveyResult/";
        this.collections.application_configuration.urlCollection = this.url + "collection/application_configuration/";
        this.collections.application_configuration_r3_admin.urlCollection = this.url + "collection/application_configuration_r3_admin/";
        this.collections.application_configuration_r3_admin_seller.urlCollection = this.url + "collection/application_configuration_r3_admin_seller/";
        this.collections.application_configuration_r3.urlCollection = this.url + "collection/application_configuration_r3/";
        this.collections.service.urlCollection = this.url + "collection/service/";
        this.collections.r3_service.urlCollection = this.url + "collection/r3_service/";
        this.views.allCompanys.urlCollection = this.url + "views/allCompanys/";
        this.views.entitiesGlobalAverageResults.urlCollection = this.url + "views/entitiesGlobalAverageResults/";
        this.views.datavizAnswerByAction.urlCollection = this.url + "views/datavizAnswerByAction/";
        this.views.datavizAnswerSummarySurveyByParentTheme.urlCollection = this.url + "views/datavizAnswerSummarySurveyByParentTheme/";
        this.views.barometreRseFIlter.urlCollection = this.url + "views/barometreRseFIlter/";
        this.views.allActionsforParentThemeByValue.urlCollection = this.url + "views/allActionsforParentThemeByValue/";
        this.views.summarysurveyTree.urlCollection = this.url + "views/summarysurveyTree/";
        this.views.datavizAnswerByActionFiltered.urlCollection = this.url + "views/datavizAnswerByActionFiltered/";
        this.views.entitiesAverageResutlsBySizeAndTheme.urlCollection = this.url + "views/entitiesAverageResutlsBySizeAndTheme/";
        this.views.avgAnswer.urlCollection = this.url + "views/avgAnswer/";
        this.views.allCompanysFormCompletedSectorAnswers.urlCollection = this.url + "views/allCompanysFormCompletedSectorAnswers/";
        this.views.nbAnswerActionByAnswer.urlCollection = this.url + "views/nbAnswerActionByAnswer/";
    }
}

// tslint:disable: max-line-length
/**
 * Routes pour la gestion des questionnaires de profiling de secteur pour la société
 */
class SectorSurvey extends HttpAbstractService {
    /**
     * Routes pour la gestion des questionnaires de profiling de secteur pour la société
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    findByIdWithAllPop(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`${id}/allPop/`, options);
    }
}

// tslint:disable: max-line-length
/**
 * envoie de mails via sendGrid
 */
class SendGrid extends HttpAbstractService {
    /**
     * envoie de mails via sendGrid
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    sendMail(body, query, templateId, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`/${templateId}/`, body, options);
    }
}

// tslint:disable: max-line-length
/**
 * route pour recuperer les articles tels que ceux pou rles intro les synthese ou les : notes
 */
class Content extends HttpAbstractService {
    /**
     * route pour recuperer les articles tels que ceux pou rles intro les synthese ou les : notes
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    getContent(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/${id}/`, options);
    }
}

// tslint:disable: max-line-length
/**
 * SummarySurvey
 */
class SummarySurvey extends HttpAbstractService {
    /**
     * SummarySurvey
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    mySurvey(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`mySurvey/${id}/`, options);
    }
    mySurveyFiltered(body, query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`mySurvey/${id}/`, body, options);
    }
}

// tslint:disable: max-line-length
/**
 * services pour le tratement du profile urilisateur
 */
class UserProfile extends HttpAbstractService {
    /**
     * services pour le tratement du profile urilisateur
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    getProfile(query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/`, options);
    }
    pathProfile(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePatch(`/`, body, options);
    }
    updatePassword(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`updatePassword`, body, options);
    }
}

// tslint:disable: max-line-length
/**
 * routes pour la gestion des authentification, création de compte et connexion avec un compte
 */
class Authentication extends HttpAbstractService {
    /**
     * routes pour la gestion des authentification, création de compte et connexion avec un compte
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    signUp(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`signUp/`, body, options);
    }
    signIn(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`signin/`, body, options);
    }
    lostPassword(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`lostPassword`, body, options);
    }
    resetPassword(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`resetPassword`, body, options);
    }
}

// tslint:disable: max-line-length
/**
 * service pour gerer les invitations
 */
class Invitations extends HttpAbstractService {
    /**
     * service pour gerer les invitations
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    sendMultiple(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`/sendMultiple`, body, options);
    }
    addMultiple(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`addMultiple`, body, options);
    }
    getAll(query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/`, options);
    }
}

// tslint:disable: max-line-length
/**
 * rip qui permet de convertir une page web en pdf
 */
class PdfRip extends HttpAbstractService {
    /**
     * rip qui permet de convertir une page web en pdf
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    generatePdf(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`generatePdf/`, body, options);
    }
}

// tslint:disable: max-line-length
/**
 * service qui retourne les token d'autorisation et les configuration des applications
 */
class LicenceToken extends HttpAbstractService {
    /**
     * service qui retourne les token d'autorisation et les configuration des applications
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    addLicence(query, appId, userId, endClientId, licenceStoreId, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/addLicence/${appId}/${userId}/${endClientId}/${licenceStoreId}/`, options);
    }
}

// tslint:disable: max-line-length
/**
 * routes utilisés pou rla page la home et autres
 */
class Home extends HttpAbstractService {
    /**
     * routes utilisés pou rla page la home et autres
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    contact(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`contact/`, body, options);
    }
    getLanding(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`home/${id}/`, options);
    }
    contactPartner(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`contactPartner/`, body, options);
    }
    partner(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`partner/${id}/`, options);
    }
    page(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`page/${id}/`, options);
    }
}

// tslint:disable: max-line-length
/**
 * service qui permet  requeter des donnes pour afficher dans le graphs de datavisualisation
 */
class Dataviz extends HttpAbstractService {
    /**
     * service qui permet  requeter des donnes pour afficher dans le graphs de datavisualisation
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    compute(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`/compute`, body, options);
    }
    summarysurveyTree(query, summaryId, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/summarysurveyTree/${summaryId}/`, options);
    }
}

// tslint:disable: max-line-length
/**
 * api des partenaire pour l'admin
 */
class AdminPartner extends HttpAbstractService {
    /**
     * api des partenaire pour l'admin
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    createParnter(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`createParnter/`, body, options);
    }
    updateParnter(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePut(`updateParnter/`, body, options);
    }
    createAdminProfileUser(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`AdminProfileUser/`, body, options);
    }
    deleteAdminProfileUser(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseDelete(`AdminProfileUser/${id}`, options);
    }
}

// tslint:disable: max-line-length
/**
 * service pour l'import et le export des donnes au format csv
 */
class CsvFileService extends HttpAbstractService {
    /**
     * service pour l'import et le export des donnes au format csv
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    exportActions(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`exportActions`, body, options);
    }
    importActions(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`importActions`, body, options);
    }
    importIssues(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`importIssues`, body, options);
    }
    exportIssues(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`exportIssues`, body, options);
    }
    importcardaction(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`importcardaction`, body, options);
    }
    exportcardaction(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`exportcardaction`, body, options);
    }
    exportDataviz(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`exportDataviz`, body, options);
    }
    exportDatavizPartner(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`exportDatavizPartner`, body, options);
    }
}

// tslint:disable: max-line-length
/**
 * service qui permet  requeter des donnes pour afficher dans le graphs de datavisualisation filtrées par partenaire
 */
class Datavizpartner extends HttpAbstractService {
    /**
     * service qui permet  requeter des donnes pour afficher dans le graphs de datavisualisation filtrées par partenaire
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    compute(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`/compute/`, body, options);
    }
    summarysurveyTree(query, summaryId, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/summarysurveyTree/${summaryId}/`, options);
    }
    companySectors(query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/companySectors/`, options);
    }
    summarysurveyTreeBySectorId(query, sectorId, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/summarysurveyTreeBySectorId/${sectorId}/`, options);
    }
    companySectorsSurvey(query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/companySectorsSurvey/`, options);
    }
}

// tslint:disable: max-line-length
/**
 * routes pour la gestion de la société, des Entities...
 */
class CompanyEntity extends HttpAbstractService {
    /**
     * routes pour la gestion de la société, des Entities...
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    addCompanyEntity(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`add/`, body, options);
    }
    saveCompanyEntitySectorSurveyAnswer(body, query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePut(`entity/${id}/sector-survey/answer/`, body, options);
    }
    setCompanyEntitySectorSurveyComplete(body, query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePut(`entity/${id}/sector-survey/complete/`, body, options);
    }
    saveCompanyEntitySummarySurveyAnswer(body, query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePut(`entity/${id}/summary-survey/answer/`, body, options);
    }
    findCompanyEntityById(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`entity/${id}`, options);
    }
    updateEntityStatesRequiredAnswers(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePut(`entity/required-answers/`, body, options);
    }
    computeThemeData(query, id, themeId, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`entity/${id}/compute-theme-data/theme/${themeId}/`, options);
    }
    selectedAction(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePatch(`entity/selectedaction`, body, options);
    }
    selectedactions(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePatch(`entity/selectedactions`, body, options);
    }
    getPdfUrl(body, query, entityId, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`entity/${entityId}/pdfUrl/`, body, options);
    }
}

// tslint:disable: max-line-length
/**
 * service api dedie aux partners
 */
class PartnerService extends HttpAbstractService {
    /**
     * service api dedie aux partners
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    informations(query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`informations/`, options);
    }
    getPartnerAdmin(query, filter, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`partnerAdmin/${filter}`, options);
    }
    createPartnerAdmin(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`partnerAdmin/`, body, options);
    }
    deletePartnerAdmin(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseDelete(`partnerAdmin/${id}/`, options);
    }
    companyEntityInfo(query, filter, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`companyEntityInfo/${filter}`, options);
    }
}

// tslint:disable: max-line-length
/**
 * routes pour la gestion de la société, des Entities...
 */
class MyCompany extends HttpAbstractService {
    /**
     * routes pour la gestion de la société, des Entities...
     */
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        super(http, secure, cached, useLocalToken);
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
    getAllCompaniesByUserId(query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/company/all-for-logged-user/`, options);
    }
    findAllCompanyEntitiesByCompanyId(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`company/${id}/companyEntities/`, options);
    }
    addCompany(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePost(`company/`, body, options);
    }
    updateCompany(body, query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.basePatch(`company/`, body, options);
    }
    resetSectorSuvey(query, id, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`company/resetSectorSuvey/${id}/`, options);
    }
    getDefaultSectorSuvey(query, options = {}) {
        const queryTxt = {};
        Object.keys(prop => {
            if (query[prop] !== null && query[prop] !== undefined) {
                queryTxt[prop] = `${query[prop]}`;
            }
        });
        const params = new HttpParams({ fromObject: Object.assign(Object.assign({}, options.params), queryTxt) });
        options.params = params;
        return this.baseGet(`/company/SectorSurvey/`, options);
    }
}

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SectorSurvey: SectorSurvey,
    SendGrid: SendGrid,
    Content: Content,
    SummarySurvey: SummarySurvey,
    UserProfile: UserProfile,
    Authentication: Authentication,
    Invitations: Invitations,
    PdfRip: PdfRip,
    LicenceToken: LicenceToken,
    Home: Home,
    Dataviz: Dataviz,
    AdminPartner: AdminPartner,
    CsvFileService: CsvFileService,
    Datavizpartner: Datavizpartner,
    CompanyEntity: CompanyEntity,
    PartnerService: PartnerService,
    MyCompany: MyCompany
});

/**
 * Generated bundle index. Do not edit.
 */

export { Api_plateforme, api_collection_plateform, api_view_allActionsforParentThemeByValue, api_view_allCompanys, api_view_allCompanysFormCompletedSectorAnswers, api_view_avgAnswer, api_view_barometreRseFIlter, api_view_datavizAnswerByAction, api_view_datavizAnswerByActionFiltered, api_view_datavizAnswerSummarySurveyByParentTheme, api_view_entitiesAverageResutlsBySizeAndTheme, api_view_entitiesGlobalAverageResults, api_view_nbAnswerActionByAnswer, api_view_plateform, api_view_summarysurveyTree, formObj_module as form, index as service };

